<template>
  <div class="page">
<!--        <button @click="getUserDept">CHECK</button>-->
    <!--    <div>-->
    <!--      <div v-for="(item, index) in allRequestTypes" :key="index">-->
    <!--        <img :src="item.image" alt="Loaded Image" class="img-tag"/>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="d-flex justify-content-between align-items-center p-3 header">
      <!--      <h3 v-if="!isMobile" class="m-3 fw-bold">Select Requests</h3>-->
      <!--      <h3 v-if="isMobile" class="m-3 fw-bold" style="font-size: 15px">Select Requests</h3>-->
      <div>
        <select v-model="selectedWallet" @change="storeSelectedWallet" class="form-select">
          <option value="" disabled>Select Wallet</option>
          <option v-for="(wallet,n) in wallets" :key="n+1" :value="wallet.id">
            {{ wallet.id }}: {{ wallet.wallet_name }}
          </option>
        </select>
      </div>
      <div class="input-group">
        <input v-model="searchTerm" autocomplete="off" name="Email" id="Email" class="input" type="email" placeholder="Search Type">
      </div>
    </div>

    <div class="cards-container">
      <div v-if="!isMobile" v-for="(card, index) in filteredTypes" :key="index" class="card" @click="navigate(card)">
        <img :src="card.image" alt="Card image" class="card-img-top" loading="lazy" decoding="async" @error="onRequestTypeImageError">
        <div class="card-body">
          <p class="card-text">{{ card.name }}</p>
        </div>
      </div>
    </div>

    <!--    <div style="width:100%;">-->
    <!--      <div class="wrapper" v-if="loading">-->
    <!--        <div class="circle"></div>-->
    <!--        <div class="circle"></div>-->
    <!--        <div class="circle"></div>-->
    <!--        <div class="shadow"></div>-->
    <!--        <div class="shadow"></div>-->
    <!--        <div class="shadow"></div>-->
    <!--      </div>-->
    <!--    </div>-->


    <!--    <div class="cards-container">-->
    <!--      <div v-if="!isMobile" v-for="(card, index) in cards" :key="index" class="card" @click="navigate(card)">-->
    <!--        <img :src="require(`@/assets/img/${card.image}`)" alt="Card image" class="card-img-top">-->
    <!--        <div class="card-body">-->
    <!--          <p class="card-text">{{ card.name }}</p>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div v-if="isMobile" v-for="(card, index) in filteredTypes" :key="index" class="card-1"  @click="navigate(card)">
      <img :src="card.image" alt="Card image" class="card-img-top" style="width: 80px; height: 80px; margin: 10px" loading="lazy" decoding="async" @error="onRequestTypeImageError">
      <div class="textBox">
        <div class="textContent">
          <p class="card-text">{{ card.name }}</p>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <!--    <div class="modal fade show" style="display: block;" v-if="showModal" tabindex="-1">-->
    <!--      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">-->
    <!--        <div class="modal-content">-->
    <!--          <div class="modal-header">-->
    <!--            <h6 class="modal-title">{{ modalTitle }}</h6>-->
    <!--            <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>-->
    <!--          </div>-->
    <!--          <div class="modal-body form-container">-->
    <!--            <form @submit.prevent="submitForm">-->
    <!--              <div v-if="selectedCard.name === 'ASSET'">-->

    <!--                <label for="subtype">Sub Type:</label>-->
    <!--                <select id="subtype" class="form-control" v-model="formData.subtype">-->
    <!--                  <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                    {{ subtype.label }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="department">Department:</label>-->
    <!--                <select-->
    <!--                    id="department"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.department"-->
    <!--                    @change="fetchData"-->
    <!--                >-->
    <!--                  <option disabled value="">Select Department</option>-->
    <!--                  <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                    {{ dept.name }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="reason" class="mt-2">Reason:</label>-->
    <!--                <input type="text" id="custom_reason" class="form-control" v-model="formData.reason">-->

    <!--                <label for="paymenttype">Account Type:</label>-->
    <!--                <select-->
    <!--                    id="paymenttype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.paymenttype"-->

    <!--                >-->
    <!--                  <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                    {{ paymenttype }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="amount" class="mt-2">Amount:</label>-->
    <!--                <input type="number" id="amount" class="form-control" v-model="formData.amount">-->

    <!--                <label for="account_number" class="mt-2">Account Number:</label>-->
    <!--                <input type="text" id="account_number" class="form-control" v-model="formData.number">-->
    <!--              </div>-->
    <!--              <div v-if="selectedCard.name === 'BUNDLE'">-->

    <!--                <label for="subtype">Sub Type:</label>-->
    <!--                <select id="subtype" class="form-control" v-model="formData.subtype">-->
    <!--                  <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                    {{ subtype.label }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="paymenttype">Account Type:</label>-->
    <!--                <select-->
    <!--                    id="paymenttype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.paymenttype"-->

    <!--                >-->
    <!--                  <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                    {{ paymenttype }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="number">Recievers Number:</label>-->
    <!--                <input type="number" id="number" class="form-control" v-model="formData.number">-->

    <!--                <label for="amount" class="mt-2">Amount:</label>-->
    <!--                <input type="number" id="amount" class="form-control" v-model="formData.amount">-->

    <!--                <label for="department">Department:</label>-->
    <!--                <select-->
    <!--                    id="department"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.department"-->
    <!--                    @change="fetchData"-->
    <!--                >-->
    <!--                  <option disabled value="">Select Department</option>-->
    <!--                  <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                    {{ dept.name }}-->
    <!--                  </option>-->
    <!--                </select>-->
    <!--              </div>-->
    <!--              <div v-if="selectedCard.name === 'EXPENSE'">-->
    <!--                <label for="subtype">Sub Type:</label>-->
    <!--                <select-->
    <!--                    id="subtype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.subtype"-->
    <!--                >-->
    <!--                  <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                    {{ subtype.label }}-->
    <!--                  </option>-->
    <!--                </select>-->
    <!--                <div v-if="formData.subtype && !['FUEL'].includes(formData.subtype)">-->
    <!--                  <label for="reason" class="mt-2">Reason:</label>-->
    <!--                  <input type="text" id="reason" class="form-control" v-model="formData.reason">-->
    <!--                </div>-->
    <!--                <label for="account_name" class="mt-2">Account number:</label>-->
    <!--                <input type="text" id="account_name" class="form-control" v-model="formData.number">-->

    <!--                <label for="paymenttype">Account Type:</label>-->
    <!--                <select-->
    <!--                    id="paymenttype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.paymenttype"-->

    <!--                >-->
    <!--                  <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                    {{ paymenttype }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="department">Department:</label>-->
    <!--                <select-->
    <!--                    id="department"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.department"-->
    <!--                    @change="fetchData"-->
    <!--                >-->
    <!--                  <option disabled value="">Select Department</option>-->
    <!--                  <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                    {{ dept.name }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="amount" class="mt-2">Amount:</label>-->
    <!--                <input type="number" id="amount" class="form-control" v-model="formData.amount">-->
    <!--                <label for="subtype">Account Type:</label>-->

    <!--                <label for="image" class="mt-2">Image:</label>-->
    <!--                <input type="file" id="image" class="form-control" @change="handleImageUpload">-->
    <!--              </div>-->
    <!--              <div v-if="selectedCard.name === 'JOBCARD'">-->
    <!--                <label for="subtype">Sub Type:</label>-->
    <!--                <select id="subtype" class="form-control" v-model="formData.subtype">-->
    <!--                  <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                    {{ subtype.label }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="paymenttype">Account Type:</label>-->
    <!--                <select-->
    <!--                    id="paymenttype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.paymenttype"-->

    <!--                >-->
    <!--                  <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                    {{ paymenttype }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="department">Department:</label>-->
    <!--                <select-->
    <!--                    id="department"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.department"-->
    <!--                    @change="fetchData"-->
    <!--                >-->
    <!--                  <option disabled value="">Select Department</option>-->
    <!--                  <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                    {{ dept.name }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="purchase_orders">Job Cards:</label>-->
    <!--                <v-select-->
    <!--                    :options="jobCardOptions"-->
    <!--                    v-model="formData.jobCard"-->
    <!--                    :reduce="jobCard=>jobCard.id"-->
    <!--                    @search="fetchJobcards"-->
    <!--                    label="title"-->
    <!--                    required-->
    <!--                ></v-select>-->
    <!--                <label for="account_name" class="mt-2">Account number:</label>-->
    <!--                <input type="text" id="account_name" class="form-control" v-model="formData.number">-->
    <!--                <label for="amount" class="mt-2">Amount:</label>-->
    <!--                <input type="number" id="amount" class="form-control" v-model="formData.amount">-->
    <!--                <label for="reason" class="mt-2">Reason:</label>-->
    <!--                <input type="text" id="reason" class="form-control" v-model="formData.reason">-->
    <!--                <label for="image" class="mt-2">Image:</label>-->
    <!--                <input type="file" id="image" class="form-control" @change="handleImageUpload">-->
    <!--              </div>-->
    <!--              <div v-if="selectedCard.name === 'OVERTIME'">-->
    <!--                <label for="subtype">Sub Type:</label>-->
    <!--                <select id="subtype" class="form-control" v-model="formData.subtype">-->
    <!--                  <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                    {{ subtype.label }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="account_name" class="mt-2">Account number:</label>-->
    <!--                <input type="text" id="account_name" class="form-control" v-model="formData.number">-->

    <!--                <label for="job_card" class="mt-2">Job Card:</label>-->
    <!--                <select id="job_card" class="form-control" v-model="formData.job_cards">-->
    <!--                  <option :value="true">True</option>-->
    <!--                  <option :value="false">False</option>-->
    <!--                </select>-->

    <!--                &lt;!&ndash; New v-select for job card numbers &ndash;&gt;-->
    <!--                <div v-if="formData.job_cards">-->
    <!--                  <label for="job_card_number" class="mt-2">Job Card Number:</label>-->
    <!--                  <v-select-->
    <!--                      :options="jobCardOptions"-->
    <!--                      v-model="formData.jobCard"-->
    <!--                      :reduce="jobCard=>jobCard.id"-->
    <!--                      @search="fetchJobcards"-->
    <!--                      label="title"-->
    <!--                  ></v-select>-->
    <!--                </div>-->

    <!--                <label for="paymenttype">Account Type:</label>-->
    <!--                <select-->
    <!--                    id="paymenttype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.paymenttype"-->

    <!--                >-->
    <!--                  <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                    {{ paymenttype }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="department">Department:</label>-->
    <!--                <select-->
    <!--                    id="department"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.department"-->
    <!--                    @change="fetchData"-->
    <!--                >-->
    <!--                  <option disabled value="">Select Department</option>-->
    <!--                  <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                    {{ dept.name }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="reason" class="mt-2">Reason:</label>-->
    <!--                <input type="text" id="custom_reason" class="form-control" v-model="formData.reason">-->

    <!--                <label for="amount" class="mt-2">Amount:</label>-->
    <!--                <input type="number" id="amount" class="form-control" v-model="formData.amount" @input="updateAmount"-->
    <!--                       readonly>-->

    <!--                &lt;!&ndash; Other OVERTIME fields... &ndash;&gt;-->
    <!--                <label for="time_worked" class="mt-2">Time Worked:</label>-->
    <!--                <input type="number" id="time_worked" class="form-control" v-model="formData.time_worked"-->
    <!--                       @input="handleTimeWorkedChange">-->

    <!--                <label for="night_or_weekend" class="mt-2">Night or Weekend:</label>-->
    <!--                <select id="night_or_weekend" class="form-control" v-model="formData.night_or_weekend"-->
    <!--                        @change="handleWeekendChange">-->
    <!--                  <option value="Night">Night</option>-->
    <!--                  <option value="Weekend">Weekend</option>-->
    <!--                </select>-->

    <!--              </div>-->
    <!--              <div v-if="selectedCard.name === 'STOCK'">-->
    <!--                <label for="purchase_orders">Purchase Orders:</label>-->
    <!--                <v-select-->
    <!--                    :options="purchaseOrders"-->
    <!--                    v-model="formData.PurchaseOrder"-->
    <!--                    :reduce="po=>po.orderNum"-->
    <!--                    label="orderNum" required-->
    <!--                ></v-select>-->
    <!--                <label for="subtype">Sub Type:</label>-->
    <!--                <select id="subtype" class="form-control" v-model="formData.subtype" required>-->
    <!--                  <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                    {{ subtype.label }}-->
    <!--                  </option>-->
    <!--                </select>-->
    <!--                <label for="account_name" class="mt-2">Account number:</label>-->
    <!--                <input type="text" id="account_name" class="form-control" v-model="formData.number" required>-->

    <!--                <label for="paymenttype">Account Type:</label>-->
    <!--                <select-->
    <!--                    id="paymenttype"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.paymenttype"-->

    <!--                >-->
    <!--                  <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                    {{ paymenttype }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="department">Department:</label>-->
    <!--                <select-->
    <!--                    id="department"-->
    <!--                    class="form-control"-->
    <!--                    v-model="formData.department"-->
    <!--                    @change="fetchData"-->
    <!--                >-->
    <!--                  <option disabled value="">Select Department</option>-->
    <!--                  <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                    {{ dept.name }}-->
    <!--                  </option>-->
    <!--                </select>-->

    <!--                <label for="image" class="mt-2">Image:</label>-->
    <!--                <input type="file" id="image" class="form-control" @change="handleImageUpload">-->
    <!--              </div>-->
    <!--              <div style="width: 100%; display: flex; justify-content: center; align-items: center;">-->
    <!--                <button type="submit" class="btn btn-primary mt-3" style="margin: 5px">Submit</button>-->
    <!--                <button type="submit" class="btn btn-primary mt-3" style="margin: 5px" @click.prevent="showBatchModal">Batch Request</button>-->
    <!--              </div>-->
    <!--            </form>-->
    <!--            <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'ASSET'">-->
    <!--              <div class="modal-contentt form-container">-->
    <!--                <div class="modal-header" >-->
    <!--                  <div style="align-items: center; width: 150px;">-->
    <!--                    <label for="subtype">Sub Type:</label>-->
    <!--                    <select id="subtype" class="form-control" v-model="subType" reuqired>-->
    <!--                      <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                        {{ subtype.label }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-bottom: 9px; margin-left: 10px; margin-right: 10px;">-->
    <!--                    <label for="reason" class="mt-2">Reason:</label>-->
    <!--                    <input type="text" id="custom_reason" class="form-control" v-model="reason" required>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center;">-->
    <!--                    <label for="department">Department:</label>-->
    <!--                    <select-->
    <!--                        id="department"-->
    <!--                        class="form-control"-->
    <!--                        v-model="selectedDepartment"-->
    <!--                        @change="fetchData"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Select Department</option>-->
    <!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                        {{ dept.name }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--                <div class="modal-bodyy">-->
    <!--                  <div-->
    <!--                      class="cardi col-md-4"-->
    <!--                      v-for="(item, index) in usersByDepartment"-->
    <!--                      :key="index"-->
    <!--                  >-->
    <!--                    <div class="cntr">-->
    <!--                      <label>-->
    <!--                        <input-->
    <!--                            type="checkbox"-->
    <!--                            :value="item.id"-->
    <!--                            @change="toggleUserSelection(item)"-->
    <!--                        />-->
    <!--                        Select-->
    <!--                      </label>-->
    <!--                    </div>-->
    <!--                    <input-->
    <!--                        type="text"-->
    <!--                        name="text"-->
    <!--                        class="input"-->
    <!--                        placeholder="Name"-->
    <!--                        v-model="item.Username"-->
    <!--                        disabled-->
    <!--                    >-->
    <!--                    <input-->
    <!--                        type="number"-->
    <!--                        class="input"-->
    <!--                        placeholder="Amount"-->
    <!--                        :value="getUserField(item.id, 'amount')"-->
    <!--                        @input="updateUserField(item.id, 'amount', $event.target.value)"-->
    <!--                    />-->
    <!--                    <div class="mob">-->
    <!--                      <input-->
    <!--                          type="text"-->
    <!--                          class="input"-->
    <!--                          placeholder="Number"-->
    <!--                          v-model="item.phone_number"-->
    <!--                      />-->
    <!--                      <div>-->
    <!--                        <select-->
    <!--                            id="paymenttype"-->
    <!--                            class="form-control"-->
    <!--                            :value="getUserField(item.id, 'provider')"-->
    <!--                            @change="updateUserField(item.id, 'provider', $event.target.value)"-->

    <!--                        >-->
    <!--                          <option disabled value="">Account Type</option>-->
    <!--                          <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                            {{ paymenttype }}-->
    <!--                          </option>-->
    <!--                        </select>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div style="display: flex; align-items: center;">-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Process"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="validateFormToSend"-->
    <!--                  />-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Close"-->
    <!--                      hoverColor="#c82333"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="closeBatchModal"-->
    <!--                  />-->
    <!--                </div>-->
    <!--                <div v-if="isLoading" class="overlay">-->
    <!--                  <section class="dots-container">-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                  </section>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'BUNDLE'">-->
    <!--              <div class="modal-contentt form-container">-->
    <!--                <div class="modal-header" >-->
    <!--                  <div style="align-items: center; width: 150px;">-->
    <!--                    <select-->
    <!--                        id="subtype"-->
    <!--                        class="form-control"-->
    <!--                        v-model="subType"-->
    <!--                        reuqired-->
    <!--                    >-->
    <!--                      <option disabled value="">Sub Type</option>-->
    <!--                      <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                        {{ subtype.label }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-left: 10px; margin-right: 10px;">-->
    <!--                    <input placeholder="Reason" type="text" id="custom_reason" class="form-control" v-model="reason" required>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center;">-->
    <!--                    <select-->
    <!--                        id="department"-->
    <!--                        class="form-control"-->
    <!--                        v-model="selectedDepartment"-->
    <!--                        @change="fetchData"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Select Department</option>-->
    <!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                        {{ dept.name }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--                <div class="modal-bodyy">-->
    <!--                  <div-->
    <!--                      class="cardi col-md-4"-->
    <!--                      v-for="(item, index) in usersByDepartment"-->
    <!--                      :key="index"-->
    <!--                  >-->
    <!--                    <div class="cntr">-->
    <!--                      <label>-->
    <!--                        <input-->
    <!--                            type="checkbox"-->
    <!--                            :value="item.id"-->
    <!--                            @change="toggleUserSelection(item)"-->
    <!--                        />-->
    <!--                        Select-->
    <!--                      </label>-->
    <!--                    </div>-->
    <!--                    <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>-->
    <!--                    <input-->
    <!--                        type="number"-->
    <!--                        class="input"-->
    <!--                        placeholder="Amount"-->
    <!--                        :value="getUserField(item.id, 'amount')"-->
    <!--                        @input="updateUserField(item.id, 'amount', $event.target.value)"-->
    <!--                    />-->
    <!--                    <div class="mob">-->
    <!--                      <input-->
    <!--                          type="text"-->
    <!--                          class="input"-->
    <!--                          placeholder="Number"-->
    <!--                          v-model="item.phone_number"-->
    <!--                      />-->
    <!--                      <div>-->
    <!--                        <select-->
    <!--                            id="paymenttype"-->
    <!--                            class="form-control"-->
    <!--                            :value="getUserField(item.id, 'provider')"-->
    <!--                            @change="updateUserField(item.id, 'provider', $event.target.value)"-->

    <!--                        >-->
    <!--                          <option disabled value="">Account Type</option>-->
    <!--                          <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                            {{ paymenttype }}-->
    <!--                          </option>-->
    <!--                        </select>-->
    <!--                      </div>-->
    <!--                    </div>-->

    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div style="display: flex; align-items: center;">-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Process"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="validateFormToSend"-->
    <!--                  />-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Close"-->
    <!--                      hoverColor="#c82333"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="closeBatchModal"-->
    <!--                  />-->
    <!--                </div>-->
    <!--                <div v-if="isLoading" class="overlay">-->
    <!--                  <section class="dots-container">-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                  </section>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'EXPENSE'">-->
    <!--              <div class="modal-contentt form-container">-->
    <!--                <div class="modal-header" >-->
    <!--                  <div style="align-items: center; width: 150px;">-->
    <!--                    <select-->
    <!--                        id="subtype"-->
    <!--                        class="form-control"-->
    <!--                        v-model="subType"-->
    <!--                        reuqired-->
    <!--                    >-->
    <!--                      <option disabled value="">Sub Type</option>-->
    <!--                      <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                        {{ subtype.label }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-left: 10px; margin-right: 10px;">-->
    <!--                    <input placeholder="Reason" type="text" id="custom_reason" class="form-control" v-model="reason" required>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center;">-->
    <!--                    <select-->
    <!--                        id="department"-->
    <!--                        class="form-control"-->
    <!--                        v-model="selectedDepartment"-->
    <!--                        @change="fetchData"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Select Department</option>-->
    <!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                        {{ dept.name }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--                <div class="modal-bodyy">-->
    <!--                  <div-->
    <!--                      class="cardi col-md-4"-->
    <!--                      v-for="(item, index) in usersByDepartment"-->
    <!--                      :key="index"-->
    <!--                  >-->
    <!--                    <div class="cntr">-->
    <!--                      <label>-->
    <!--                        <input-->
    <!--                            type="checkbox"-->
    <!--                            :value="item.id"-->
    <!--                            @change="toggleUserSelection(item)"-->
    <!--                        />-->
    <!--                        Select-->
    <!--                      </label>-->
    <!--                    </div>-->
    <!--                    <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>-->
    <!--                    <input-->
    <!--                        type="number"-->
    <!--                        class="input"-->
    <!--                        placeholder="Amount"-->
    <!--                        :value="getUserField(item.id, 'amount')"-->
    <!--                        @input="updateUserField(item.id, 'amount', $event.target.value)"-->
    <!--                    />-->
    <!--                    <div class="mob">-->
    <!--                      <input-->
    <!--                          type="text"-->
    <!--                          class="input"-->
    <!--                          placeholder="Number"-->
    <!--                          v-model="item.phone_number"-->
    <!--                      />-->
    <!--                      <div>-->
    <!--                        <select-->
    <!--                            id="paymenttype"-->
    <!--                            class="form-control"-->
    <!--                            :value="getUserField(item.id, 'provider')"-->
    <!--                            @change="updateUserField(item.id, 'provider', $event.target.value)"-->

    <!--                        >-->
    <!--                          <option disabled value="">Account Type</option>-->
    <!--                          <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                            {{ paymenttype }}-->
    <!--                          </option>-->
    <!--                        </select>-->
    <!--                      </div>-->
    <!--                    </div>-->

    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div style="display: flex; align-items: center;">-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Process"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="validateFormToSend"-->
    <!--                  />-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Close"-->
    <!--                      hoverColor="#c82333"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="closeBatchModal"-->
    <!--                  />-->
    <!--                </div>-->
    <!--                <div v-if="isLoading" class="overlay">-->
    <!--                  <section class="dots-container">-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                  </section>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'JOBCARD'">-->
    <!--              <div class="modal-contentt form-container">-->
    <!--                <div class="modal-header" >-->
    <!--                  <div style="align-items: center; width: 150px;">-->
    <!--                    <select-->
    <!--                        id="subtype"-->
    <!--                        class="form-control"-->
    <!--                        v-model="subType"-->
    <!--                        reuqired-->
    <!--                    >-->
    <!--                      <option disabled value="">Sub Type</option>-->
    <!--                      <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                        {{ subtype.label }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-left: 10px; margin-right: 10px;">-->
    <!--                    <input placeholder="Reason" type="text" id="custom_reason" class="form-control" v-model="reason" required>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center;">-->
    <!--                    <select-->
    <!--                        id="department"-->
    <!--                        class="form-control"-->
    <!--                        v-model="selectedDepartment"-->
    <!--                        @change="fetchData"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Select Department</option>-->
    <!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                        {{ dept.name }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--                <div class="modal-bodyy">-->
    <!--                  <div-->
    <!--                      class="cardi col-md-4"-->
    <!--                      v-for="(item, index) in usersByDepartment"-->
    <!--                      :key="index"-->
    <!--                  >-->
    <!--                    <div class="cntr">-->
    <!--                      <label>-->
    <!--                        <input-->
    <!--                            type="checkbox"-->
    <!--                            :value="item.id"-->
    <!--                            @change="toggleUserSelection(item)"-->
    <!--                        />-->
    <!--                        Select-->
    <!--                      </label>-->
    <!--                    </div>-->
    <!--                    <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>-->
    <!--                    <input-->
    <!--                        type="number"-->
    <!--                        class="input"-->
    <!--                        placeholder="Amount"-->
    <!--                        :value="getUserField(item.id, 'amount')"-->
    <!--                        @input="updateUserField(item.id, 'amount', $event.target.value)"-->
    <!--                    />-->
    <!--                    <div class="mob">-->
    <!--                      <input-->
    <!--                          type="text"-->
    <!--                          class="input"-->
    <!--                          placeholder="Number"-->
    <!--                          v-model="item.phone_number"-->
    <!--                      />-->
    <!--                      <div>-->
    <!--                        <select-->
    <!--                            id="paymenttype"-->
    <!--                            class="form-control"-->
    <!--                            :value="getUserField(item.id, 'provider')"-->
    <!--                            @change="updateUserField(item.id, 'provider', $event.target.value)"-->

    <!--                        >-->
    <!--                          <option disabled value="">Account Type</option>-->
    <!--                          <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                            {{ paymenttype }}-->
    <!--                          </option>-->
    <!--                        </select>-->
    <!--                      </div>-->
    <!--                      <div>-->
    <!--                        <v-select-->
    <!--                            :options="jobCardOptions"-->
    <!--                            v-model="jobCards"-->
    <!--                            :reduce="jobCard=>jobCard.id"-->
    <!--                            @search="fetchJobcards"-->
    <!--                            label="title"-->
    <!--                            required-->
    <!--                        ></v-select>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div style="display: flex; align-items: center;">-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Process"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="validateFormToSend"-->
    <!--                  />-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Close"-->
    <!--                      hoverColor="#c82333"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="closeBatchModal"-->
    <!--                  />-->
    <!--                </div>-->
    <!--                <div v-if="isLoading" class="overlay">-->
    <!--                  <section class="dots-container">-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                  </section>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'OVERTIME'">-->
    <!--              <div class="modal-contentt form-container">-->
    <!--                <div class="modal-header flex-wrap" >-->
    <!--                  <div style="align-items: center; width: 150px;">-->
    <!--                    <select-->
    <!--                        id="subtype"-->
    <!--                        class="form-control"-->
    <!--                        v-model="subType"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Sub Type</option>-->
    <!--                      <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                        {{ subtype.label }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="margin-left: 5px">-->
    <!--                    <select-->
    <!--                        id="night_or_weekend"-->
    <!--                        class="form-control"-->
    <!--                        v-model="timeWorked"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">when</option>-->
    <!--                      <option value="Night">Night</option>-->
    <!--                      <option value="Weekend">Weekend</option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-left: 10px; margin-right: 10px;">-->
    <!--                    <input placeholder="Reason" type="text" id="custom_reason" class="form-control" style="width: 100px" v-model="reason" required>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center;">-->
    <!--                    <select-->
    <!--                        id="department"-->
    <!--                        class="form-control"-->
    <!--                        v-model="selectedDepartment"-->
    <!--                        @change="fetchData"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Select Department</option>-->
    <!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                        {{ dept.name }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--                <div class="modal-bodyy">-->
    <!--                  <div-->
    <!--                      class="cardi col-md-4"-->
    <!--                      v-for="(item, index) in usersByDepartment"-->
    <!--                      :key="index"-->
    <!--                  >-->
    <!--                    <div class="cntr">-->
    <!--                      <label>-->
    <!--                        <input-->
    <!--                            type="checkbox"-->
    <!--                            :value="item.id"-->
    <!--                            @change="toggleUserSelection(item)"-->
    <!--                        />-->
    <!--                        Select-->
    <!--                      </label>-->
    <!--                    </div>-->
    <!--                    <div style="display: flex">-->
    <!--                      <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>-->
    <!--                      <input-->
    <!--                          type="number"-->
    <!--                          class="input"-->
    <!--                          placeholder="Amount"-->
    <!--                          :value="getUserField(item.id, 'amount')"-->
    <!--                          @input="updateUserField(item.id, 'amount', $event.target.value)"-->
    <!--                      />-->
    <!--                    </div>-->
    <!--                    <div class="mob">-->
    <!--                      <input-->
    <!--                          type="text"-->
    <!--                          class="input"-->
    <!--                          placeholder="Number"-->
    <!--                          v-model="item.phone_number"-->

    <!--                      />-->
    <!--                      <div>-->
    <!--                        <select-->
    <!--                            id="paymenttype"-->
    <!--                            class="form-control"-->
    <!--                            :value="getUserField(item.id, 'provider')"-->
    <!--                            @change="updateUserField(item.id, 'provider', $event.target.value)"-->

    <!--                        >-->
    <!--                          <option disabled value="">Account Type</option>-->
    <!--                          <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                            {{ paymenttype }}-->
    <!--                          </option>-->
    <!--                        </select>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                    <div class="mob">-->
    <!--                      <div style="justify-content: space-between; margin-left: 10px">-->
    <!--                        <label for="job_card" class="mt-2">Job Card:</label>-->
    <!--                        <select-->
    <!--                            id="job_card"-->
    <!--                            class="form-control"-->
    <!--                            v-model="item.jobCards"-->
    <!--                        >-->
    <!--                          <option disabled value="">Job Card</option>-->
    <!--                          <option :value="true">True</option>-->
    <!--                          <option :value="false">False</option>-->
    <!--                        </select>-->
    <!--                      </div>-->

    <!--                      &lt;!&ndash; New v-select for job card numbers &ndash;&gt;-->
    <!--                      <div v-if="item.jobCards">-->
    <!--                        <label for="job_card_number" class="mt-2">Job Card Number:</label>-->
    <!--                        <v-select-->
    <!--                            :options="jobCardOptions"-->
    <!--                            :value="getUserField(item.id, 'jobCard')"-->
    <!--                            @change="updateUserField(item.id, 'jobCard', $event.target.value)"-->
    <!--                            :reduce="jobCard=>jobCard.id"-->
    <!--                            @search="fetchJobcards"-->
    <!--                            label="title"-->
    <!--                        ></v-select>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div style="display: flex; align-items: center;">-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Process"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="validateFormToSend"-->
    <!--                  />-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Close"-->
    <!--                      hoverColor="#c82333"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="closeBatchModal"-->
    <!--                  />-->
    <!--                </div>-->
    <!--                <div v-if="isLoading" class="overlay">-->
    <!--                  <section class="dots-container">-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                  </section>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'STOCK'">-->
    <!--              <div class="modal-contentt form-container">-->
    <!--                <div class="modal-header">-->
    <!--                  <div style="align-items: center; width: 150px;">-->
    <!--                    <label for="subtype">Sub Type:</label>-->
    <!--                    <select id="subtype" class="form-control" v-model="subType" reuqired>-->
    <!--                      <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">-->
    <!--                        {{ subtype.label }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-left: 10px">-->
    <!--                    <label for="department">Department:</label>-->
    <!--                    <select-->
    <!--                        id="department"-->
    <!--                        class="form-control"-->
    <!--                        v-model="selectedDepartment"-->
    <!--                        @change="fetchData"-->
    <!--                        required-->
    <!--                    >-->
    <!--                      <option disabled value="">Select Department</option>-->
    <!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
    <!--                        {{ dept.name }}-->
    <!--                      </option>-->
    <!--                    </select>-->
    <!--                  </div>-->
    <!--                  <div style="align-items: center; margin-left: 10px">-->
    <!--                    <label for="purchase_orders">Purchase Orders:</label>-->
    <!--                    <v-select-->
    <!--                        :options="purchaseOrders"-->
    <!--                        v-model="orders"-->
    <!--                        :reduce="po=>po.orderNum"-->
    <!--                        label="orderNum" required-->
    <!--                    ></v-select>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--                <div class="modal-bodyy">-->
    <!--                  <div-->
    <!--                      class="cardi col-md-4"-->
    <!--                      v-for="(item, index) in usersByDepartment"-->
    <!--                      :key="index"-->
    <!--                  >-->
    <!--                    <div class="cntr">-->
    <!--                      <label>-->
    <!--                        <input-->
    <!--                            type="checkbox"-->
    <!--                            :value="item.id"-->
    <!--                            @change="toggleUserSelection(item)"-->
    <!--                        />-->
    <!--                        Select-->
    <!--                      </label>-->
    <!--                    </div>-->
    <!--                    &lt;!&ndash;            <p style="font-weight: 600; padding: 10px">Bwezani Kanyimbi</p>&ndash;&gt;-->
    <!--                    <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>-->
    <!--                    <div class="mob">-->
    <!--                      <input-->
    <!--                          type="text"-->
    <!--                          class="input"-->
    <!--                          placeholder="Number"-->
    <!--                          v-model="item.phone_number"-->
    <!--                      />-->
    <!--                      <div>-->
    <!--                        <select-->
    <!--                            id="paymenttype"-->
    <!--                            class="form-control"-->
    <!--                            :value="getUserField(item.id, 'provider')"-->
    <!--                            @change="updateUserField(item.id, 'provider', $event.target.value)"-->

    <!--                        >-->
    <!--                          <option disabled value="">Account Type</option>-->
    <!--                          <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
    <!--                            {{ paymenttype }}-->
    <!--                          </option>-->
    <!--                        </select>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div style="display: flex; align-items: center;">-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Process"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="validateFormToSend"-->
    <!--                  />-->
    <!--                  <ApproveButton-->
    <!--                      button-text="Close"-->
    <!--                      hoverColor="#c82333"-->
    <!--                      hoverTextColor="#ffffff"-->
    <!--                      @click="closeBatchModal"-->
    <!--                  />-->
    <!--                </div>-->
    <!--                <div v-if="isLoading" class="overlay">-->
    <!--                  <section class="dots-container">-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                    <div class="dot"></div>-->
    <!--                  </section>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="overlay" v-if="showModal">
      <div class="modal fade show" style="display: block;" v-if="showModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
          <div class="modal-content" style="background-color: aliceblue">
            <div class="modal-header">
              <h6 class="modal-title">{{ modalTitle }}</h6>
              <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
            </div>
            <div class="modal-body form-container">
              <form @submit.prevent="submitForm">
                <div>

<!--                  <div>-->
<!--                    <label for="department">Department:</label>-->
<!--                    <select-->
<!--                        id="department"-->
<!--                        class="form-control"-->
<!--                        v-model="formData.department"-->
<!--                        @change="fetchData"-->
<!--                        required-->
<!--                    >-->
<!--                      <option disabled value="">Select Department</option>-->
<!--                      <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">-->
<!--                        {{ dept.name }}-->
<!--                      </option>-->
<!--                    </select>-->
<!--                  </div>-->

                  <div v-if="subtypes.length > 0">
                    <label for="subtype">Sub Type:</label>
                    <select id="subtype" class="form-control" v-model="formData.subtype" required>
                      <option disabled value="">Select Sub Type</option>
                      <option v-for="subtype in subtypes" :key="subtype.id" :value="subtype.name">
                        {{ subtype.name }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label for="reason" class="mt-2">Reason:</label>
                    <input type="text" id="custom_reason" class="form-control" v-model="formData.reason" required>
                  </div>

                  <div>
                    <label for="paymenttype">Account Type:</label>
                    <select
                        id="paymenttype"
                        class="form-control"
                        v-model="formData.paymenttype"
                        required
                    >
                      <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                        {{ paymenttype }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label for="account_number" class="mt-2">Account Number:</label>
                    <input
                        type="text"
                        id="account_number"
                        class="form-control"
                        v-model="formData.number"
                        v-if="!carrier"
                        required
                    >
                  </div>

                  <vuePhoneNumberInput
                      :only-countries="[`ZM`,`ZW`,`ZA`,`MW`,`BW`,`CD`,`CG`,`ET`]"
                      v-model="formData.number"
                      v-if="carrier"
                      default-country-code="ZM"
                      size="lg"
                      @update="validateCarrier"
                      required clearable
                  />
                  <div v-if="carrier" class="mt-2 d-flex align-items-center flex-wrap gap-2">
                    <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        :disabled="!canUseContactPicker"
                        @click="pickContact"
                    >
                      Select Contact
                    </button>
                    <small class="text-muted" v-if="canUseContactPicker">
                      Filters to {{ getCarrierLabel(formData.paymenttype) }} prefixes: {{ getCarrierPrefixes(formData.paymenttype).join(', ') }}
                    </small>
                    <small class="text-muted" v-else>
                      Contact picker not supported in this browser/device.
                    </small>
                  </div>

                  <!--                  <vuePhoneNumberInput-->
                  <!--                      ref="phoneInput"-->
                  <!--                      v-model="formData.number"-->
                  <!--                      :only-countries="['ZM']"-->
                  <!--                      default-country-code="ZM"-->
                  <!--                      size="lg"-->
                  <!--                      clearable-->
                  <!--                      required-->
                  <!--                      @update="validateCarrier"-->
                  <!--                  />-->

                  <div class="modal-overlay" v-if="contactModalVisible">
                    <div class="modal-content form-container" style="max-width: 500px; margin: auto;">
                      <div class="modal-header">
                        <h6 class="modal-title">Select Contact</h6>
                        <button type="button" class="btn-close" @click="closeContactModal" aria-label="Close"></button>
                      </div>
                      <div class="modal-bodyy">
                        <input
                            class="form-control mb-2"
                            type="text"
                            placeholder="Search contacts"
                            v-model="contactSearch"
                        />
                        <div v-if="!filteredContactOptions.length" class="text-center text-muted py-2">
                          No contacts match the selected prefixes.
                        </div>
                        <ul class="list-group">
                          <li
                              class="list-group-item list-group-item-action"
                              v-for="(option, idx) in filteredContactOptions"
                              :key="idx"
                              @click="selectContact(option)"
                              style="cursor: pointer"
                          >
                            <div class="fw-bold">{{ option.name || 'Unknown' }}</div>
                            <div class="text-muted small">Raw: {{ option.raw }} | Local: {{ option.local }}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Shipping Expense: Supplier -->
                  <div v-if="nameType === 'Shipping Expense'">
                    <label for="supplier" class="mt-2">Supplier:</label>
                    <select id="supplier" class="form-control" v-model="formData.supplier" required>
                      <option disabled value="">Select Supplier</option>
                      <option v-for="s in suppliers" :key="s.SupplierName" :value="s.SupplierName">
                        {{ s.SupplierName }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label for="amount" class="mt-2">Amount:</label>
                    <input
                        type="number"
                        id="amount"
                        class="form-control"
                        v-model="formData.amount"
                        required
                    >
                  </div>

                  <div v-if="options.options.hasTime">
                    <label for="time_worked" class="mt-2">Time Worked:</label>
                    <input type="number" id="time_worked" class="form-control" v-model="formData.time_worked" @input="handleTimeWorkedChange" required>
                  </div>

                  <div v-if="options.options.hasTime">
                    <label for="night_or_weekend" class="mt-2">Night or Weekend:</label>
                    <select id="night_or_weekend" class="form-control" v-model="formData.night_or_weekend"
                            @change="handleWeekendChange" required>
                      <option value="Night">Night</option>
                      <option value="Weekend">Weekend</option>
                    </select>
                  </div>

<!--                  <div v-if="options.options.hasJobCardHeaderId">-->
<!--                    <label for="job_card" class="mt-2">Job Card:</label>-->
<!--                    <select id="job_card" class="form-control" v-model="formData.job_cards">-->
<!--                      <option :value="true">True</option>-->
<!--                      <option :value="false">False</option>-->
<!--                    </select>-->
<!--                  </div>-->

<!--                  <div v-if="options.options.hasJobCardHeaderId">-->
<!--                    <label for="purchase_orders">Job Cards:</label>-->
<!--                    <v-select-->
<!--                        :options="jobCardOptions"-->
<!--                        v-model="formData.jobCard"-->
<!--                        :reduce="jobCard=>jobCard.id"-->
<!--                        @search="fetchJobcards"-->
<!--                        label="title"-->
<!--                        required-->
<!--                    ></v-select>-->
<!--                  </div>-->

                  <div v-if="options.options.hasPurchaseOrder">
                    <label for="purchase_orders">Purchase Orders:</label>
                    <v-select
                        :options="purchaseOrders"
                        v-model="formData.PurchaseOrder"
                        :reduce="po=>po.orderNum"
                        label="orderNum" required
                    ></v-select>
                  </div>

                  <div v-if="options.options.hasImageId">
                    <label for="image" class="mt-2">Image:</label>
                    <input type="file" id="image" class="form-control" @change="handleImageUpload" required>
                  </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
                  <button type="submit" class="btn btn-primary mt-3" style="margin: 5px">Submit</button>
                  <button type="submit" class="btn btn-primary mt-3" style="margin: 5px" @click.prevent="showBatchModal">Batch Request</button>
                </div>
              </form>
              <div class="modal-overlay" v-if="batchModalVisible">
                <div class="modal-contentt form-container">
                  <div class="modal-header flex-wrap" >
                    <div style="align-items: center; width: 150px;">
                      <label for="subtype">Sub Type:</label>
                      <select id="subtype" class="form-control" v-model="formData.subtype">
                        <option v-for="subtype in subtypes" :key="subtype.id" :value="subtype.name">
                          {{ subtype.name }}
                        </option>
                      </select>
                    </div>
                    <div style="margin-left: 5px" v-if="options.options.hasTime">
                      <select
                          id="night_or_weekend"
                          class="form-control"
                          v-model="timeWorked"
                          required
                      >
                        <option disabled value="">when</option>
                        <option value="Night">Night</option>
                        <option value="Weekend">Weekend</option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-bottom: 9px; margin-left: 10px; margin-right: 10px;">
                      <label for="reason" class="mt-2">Reason:</label>
                      <input type="text" id="custom_reason" class="form-control" v-model="reason" required>
                    </div>
                    <div style="align-items: center;">
                      <label for="department">Department:</label>
                      <select
                          id="department"
                          class="form-control"
                          v-model="selectedDepartment"
                          @change="fetchData"
                          required
                      >
                        <option disabled value="">Select Department</option>
                        <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px" v-if="options.options.hasPurchaseOrder">
                      <label for="purchase_orders">Purchase Orders:</label>
                      <v-select
                          :options="purchaseOrders"
                          v-model="orders"
                          :reduce="po=>po.orderNum"
                          label="orderNum" required
                      ></v-select>
                    </div>
                  </div>

                  <div class="modal-bodyy"
                  >
                    <div
                        class="cardi col-md-4"
                        v-for="(item, index) in usersByDepartment"
                        :key="index"
                    >
                      <div class="cntr">
                        <label>
                          <input
                              type="checkbox"
                              :value="item.id"
                              @change="toggleUserSelection(item)"
                          />
                          Select
                        </label>
                      </div>
                      <div style="display: flex">
                        <input
                            type="text"
                            name="text"
                            class="input"
                            placeholder="Name"
                            v-model="item.Username"
                            disabled
                        >
                        <input
                            type="number"
                            class="input"
                            placeholder="Amount"
                            :value="getUserField(item.id, 'amount')"
                            @input="updateUserField(item.id, 'amount', $event.target.value)"
                        />
                      </div>
                      <div class="mob">
                        <input
                            type="text"
                            class="input"
                            placeholder="Number"
                            v-model="item.phone_number"
                        />
                        <div>
                          <select
                              id="paymenttype"
                              class="form-control"
                              :value="getUserField(item.id, 'provider')"
                              @change="updateUserField(item.id, 'provider', $event.target.value)"

                          >
                            <option disabled value="">Account Type</option>
                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                              {{ paymenttype }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mob" v-if="options.options.hasJobCardHeaderId">
                        <div style="justify-content: space-between; margin-left: 10px">
                          <label for="job_card" class="mt-2">Job Card:</label>
                          <select
                              id="job_card"
                              class="form-control"
                              v-model="item.jobCards"
                          >
                            <option disabled value="">Job Card</option>
                            <option :value="true">True</option>
                            <option :value="false">False</option>
                          </select>
                        </div>

                        <!-- New v-select for job card numbers -->
                        <div v-if="item.jobCards">
                          <label for="job_card_number" class="mt-2">Job Card Number:</label>
                          <v-select
                              :options="jobCardOptions"
                              :value="getUserField(item.id, 'jobCard')"
                              @change="updateUserField(item.id, 'jobCard', $event.target.value)"
                              :reduce="jobCard=>jobCard.id"
                              @search="fetchJobcards"
                              label="title"
                          ></v-select>
                        </div>
                      </div>
                      <!--                    <input-->
                      <!--                        type="text"-->
                      <!--                        name="text"-->
                      <!--                        class="input"-->
                      <!--                        placeholder="Name"-->
                      <!--                        v-model="item.Username"-->
                      <!--                        disabled-->
                      <!--                    >-->
                      <!--                    <input-->
                      <!--                        type="number"-->
                      <!--                        class="input"-->
                      <!--                        placeholder="Amount"-->
                      <!--                        :value="getUserField(item.id, 'amount')"-->
                      <!--                        @input="updateUserField(item.id, 'amount', $event.target.value)"-->
                      <!--                    />-->
                      <!--                      <div style="display: flex">-->
                      <!--                        <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>-->
                      <!--                        <input-->
                      <!--                            type="number"-->
                      <!--                            class="input"-->
                      <!--                            placeholder="Amount"-->
                      <!--                            :value="getUserField(item.id, 'amount')"-->
                      <!--                            @input="updateUserField(item.id, 'amount', $event.target.value)"-->
                      <!--                        />-->
                      <!--                      </div>-->
                      <!--                      <div class="mob">-->
                      <!--                        <input-->
                      <!--                            type="text"-->
                      <!--                            class="input"-->
                      <!--                            placeholder="Number"-->
                      <!--                            v-model="item.phone_number"-->

                      <!--                        />-->
                      <!--                        <div>-->
                      <!--                          <select-->
                      <!--                              id="paymenttype"-->
                      <!--                              class="form-control"-->
                      <!--                              :value="getUserField(item.id, 'provider')"-->
                      <!--                              @change="updateUserField(item.id, 'provider', $event.target.value)"-->

                      <!--                          >-->
                      <!--                            <option disabled value="">Account Type</option>-->
                      <!--                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">-->
                      <!--                              {{ paymenttype }}-->
                      <!--                            </option>-->
                      <!--                          </select>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <ApproveButton
                        button-text="Process"
                        hoverTextColor="#ffffff"
                        @click="validateFormToSend"
                    />
                    <ApproveButton
                        button-text="Close"
                        hoverColor="#c82333"
                        hoverTextColor="#ffffff"
                        @click="closeBatchModal"
                    />
                  </div>
                  <div v-if="isLoading" class="overlay">
                    <section class="dots-container">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'BUNDLE'">
                <div class="modal-contentt form-container">
                  <div class="modal-header" >
                    <div style="align-items: center; width: 150px;">
                      <select
                          id="subtype"
                          class="form-control"
                          v-model="subType"
                          reuqired
                      >
                        <option disabled value="">Sub Type</option>
                        <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">
                          {{ subtype.label }}
                        </option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px; margin-right: 10px;">
                      <input placeholder="Reason" type="text" id="custom_reason" class="form-control" v-model="reason" required>
                    </div>
                    <div style="align-items: center;">
                      <select
                          id="department"
                          class="form-control"
                          v-model="selectedDepartment"
                          @change="fetchData"
                          required
                      >
                        <option disabled value="">Select Department</option>
                        <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="modal-bodyy">
                    <div
                        class="cardi col-md-4"
                        v-for="(item, index) in usersByDepartment"
                        :key="index"
                    >
                      <div class="cntr">
                        <label>
                          <input
                              type="checkbox"
                              :value="item.id"
                              @change="toggleUserSelection(item)"
                          />
                          Select
                        </label>
                      </div>
                      <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>
                      <input
                          type="number"
                          class="input"
                          placeholder="Amount"
                          :value="getUserField(item.id, 'amount')"
                          @input="updateUserField(item.id, 'amount', $event.target.value)"
                      />
                      <div class="mob">
                        <input
                            type="text"
                            class="input"
                            placeholder="Number"
                            v-model="item.phone_number"
                        />
                        <div>
                          <select
                              id="paymenttype"
                              class="form-control"
                              :value="getUserField(item.id, 'provider')"
                              @change="updateUserField(item.id, 'provider', $event.target.value)"

                          >
                            <option disabled value="">Account Type</option>
                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                              {{ paymenttype }}
                            </option>
                          </select>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <ApproveButton
                        button-text="Process"
                        hoverTextColor="#ffffff"
                        @click="validateFormToSend"
                    />
                    <ApproveButton
                        button-text="Close"
                        hoverColor="#c82333"
                        hoverTextColor="#ffffff"
                        @click="closeBatchModal"
                    />
                  </div>
                  <div v-if="isLoading" class="overlay">
                    <section class="dots-container">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'EXPENSE'">
                <div class="modal-contentt form-container">
                  <div class="modal-header" >
                    <div style="align-items: center; width: 150px;">
                      <select
                          id="subtype"
                          class="form-control"
                          v-model="subType"
                          reuqired
                      >
                        <option disabled value="">Sub Type</option>
                        <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">
                          {{ subtype.label }}
                        </option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px; margin-right: 10px;">
                      <input placeholder="Reason" type="text" id="custom_reason" class="form-control" v-model="reason" required>
                    </div>
                    <div style="align-items: center;">
                      <select
                          id="department"
                          class="form-control"
                          v-model="selectedDepartment"
                          @change="fetchData"
                          required
                      >
                        <option disabled value="">Select Department</option>
                        <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="modal-bodyy">
                    <div
                        class="cardi col-md-4"
                        v-for="(item, index) in usersByDepartment"
                        :key="index"
                    >
                      <div class="cntr">
                        <label>
                          <input
                              type="checkbox"
                              :value="item.id"
                              @change="toggleUserSelection(item)"
                          />
                          Select
                        </label>
                      </div>
                      <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>
                      <input
                          type="number"
                          class="input"
                          placeholder="Amount"
                          :value="getUserField(item.id, 'amount')"
                          @input="updateUserField(item.id, 'amount', $event.target.value)"
                      />
                      <div class="mob">
                        <input
                            type="text"
                            class="input"
                            placeholder="Number"
                            v-model="item.phone_number"
                        />
                        <div>
                          <select
                              id="paymenttype"
                              class="form-control"
                              :value="getUserField(item.id, 'provider')"
                              @change="updateUserField(item.id, 'provider', $event.target.value)"

                          >
                            <option disabled value="">Account Type</option>
                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                              {{ paymenttype }}
                            </option>
                          </select>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <ApproveButton
                        button-text="Process"
                        hoverTextColor="#ffffff"
                        @click="validateFormToSend"
                    />
                    <ApproveButton
                        button-text="Close"
                        hoverColor="#c82333"
                        hoverTextColor="#ffffff"
                        @click="closeBatchModal"
                    />
                  </div>
                  <div v-if="isLoading" class="overlay">
                    <section class="dots-container">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'JOBCARD'">
                <div class="modal-contentt form-container">
                  <div class="modal-header" >
                    <div style="align-items: center; width: 150px;">
                      <select
                          id="subtype"
                          class="form-control"
                          v-model="subType"
                          reuqired
                      >
                        <option disabled value="">Sub Type</option>
                        <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">
                          {{ subtype.label }}
                        </option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px; margin-right: 10px;">
                      <input placeholder="Reason" type="text" id="custom_reason" class="form-control" v-model="reason" required>
                    </div>
                    <div style="align-items: center;">
                      <select
                          id="department"
                          class="form-control"
                          v-model="selectedDepartment"
                          @change="fetchData"
                          required
                      >
                        <option disabled value="">Select Department</option>
                        <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="modal-bodyy">
                    <div
                        class="cardi col-md-4"
                        v-for="(item, index) in usersByDepartment"
                        :key="index"
                    >
                      <div class="cntr">
                        <label>
                          <input
                              type="checkbox"
                              :value="item.id"
                              @change="toggleUserSelection(item)"
                          />
                          Select
                        </label>
                      </div>
                      <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>
                      <input
                          type="number"
                          class="input"
                          placeholder="Amount"
                          :value="getUserField(item.id, 'amount')"
                          @input="updateUserField(item.id, 'amount', $event.target.value)"
                      />
                      <div class="mob">
                        <input
                            type="text"
                            class="input"
                            placeholder="Number"
                            v-model="item.phone_number"
                        />
                        <div>
                          <select
                              id="paymenttype"
                              class="form-control"
                              :value="getUserField(item.id, 'provider')"
                              @change="updateUserField(item.id, 'provider', $event.target.value)"

                          >
                            <option disabled value="">Account Type</option>
                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                              {{ paymenttype }}
                            </option>
                          </select>
                        </div>
                        <div>
                          <v-select
                              :options="jobCardOptions"
                              v-model="jobCards"
                              :reduce="jobCard=>jobCard.id"
                              @search="fetchJobcards"
                              label="title"
                              required
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <ApproveButton
                        button-text="Process"
                        hoverTextColor="#ffffff"
                        @click="validateFormToSend"
                    />
                    <ApproveButton
                        button-text="Close"
                        hoverColor="#c82333"
                        hoverTextColor="#ffffff"
                        @click="closeBatchModal"
                    />
                  </div>
                  <div v-if="isLoading" class="overlay">
                    <section class="dots-container">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'OVERTIME'">
                <div class="modal-contentt form-container">
                  <div class="modal-header flex-wrap" >
                    <div style="align-items: center; width: 150px;">
                      <select
                          id="subtype"
                          class="form-control"
                          v-model="subType"
                          required
                      >
                        <option disabled value="">Sub Type</option>
                        <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">
                          {{ subtype.label }}
                        </option>
                      </select>
                    </div>
                    <div style="margin-left: 5px">
                      <select
                          id="night_or_weekend"
                          class="form-control"
                          v-model="timeWorked"
                          required
                      >
                        <option disabled value="">when</option>
                        <option value="Night">Night</option>
                        <option value="Weekend">Weekend</option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px; margin-right: 10px;">
                      <input placeholder="Reason" type="text" id="custom_reason" class="form-control" style="width: 100px" v-model="reason" required>
                    </div>
                    <div style="align-items: center;">
                      <select
                          id="department"
                          class="form-control"
                          v-model="selectedDepartment"
                          @change="fetchData"
                          required
                      >
                        <option disabled value="">Select Department</option>
                        <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="modal-bodyy">
                    <div
                        class="cardi col-md-4"
                        v-for="(item, index) in usersByDepartment"
                        :key="index"
                    >
                      <div class="cntr">
                        <label>
                          <input
                              type="checkbox"
                              :value="item.id"
                              @change="toggleUserSelection(item)"
                          />
                          Select
                        </label>
                      </div>
                      <div style="display: flex">
                        <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>
                        <input
                            type="number"
                            class="input"
                            placeholder="Amount"
                            :value="getUserField(item.id, 'amount')"
                            @input="updateUserField(item.id, 'amount', $event.target.value)"
                        />
                      </div>
                      <div class="mob">
                        <input
                            type="text"
                            class="input"
                            placeholder="Number"
                            v-model="item.phone_number"

                        />
                        <div>
                          <select
                              id="paymenttype"
                              class="form-control"
                              :value="getUserField(item.id, 'provider')"
                              @change="updateUserField(item.id, 'provider', $event.target.value)"

                          >
                            <option disabled value="">Account Type</option>
                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                              {{ paymenttype }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mob">
                        <div style="justify-content: space-between; margin-left: 10px">
                          <label for="job_card" class="mt-2">Job Card:</label>
                          <select
                              id="job_card"
                              class="form-control"
                              v-model="item.jobCards"
                          >
                            <option disabled value="">Job Card</option>
                            <option :value="true">True</option>
                            <option :value="false">False</option>
                          </select>
                        </div>

                        <!-- New v-select for job card numbers -->
                        <div v-if="item.jobCards">
                          <label for="job_card_number" class="mt-2">Job Card Number:</label>
                          <v-select
                              :options="jobCardOptions"
                              :value="getUserField(item.id, 'jobCard')"
                              @change="updateUserField(item.id, 'jobCard', $event.target.value)"
                              :reduce="jobCard=>jobCard.id"
                              @search="fetchJobcards"
                              label="title"
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <ApproveButton
                        button-text="Process"
                        hoverTextColor="#ffffff"
                        @click="validateFormToSend"
                    />
                    <ApproveButton
                        button-text="Close"
                        hoverColor="#c82333"
                        hoverTextColor="#ffffff"
                        @click="closeBatchModal"
                    />
                  </div>
                  <div v-if="isLoading" class="overlay">
                    <section class="dots-container">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="modal-overlay" v-if="batchModalVisible && selectedCard.name === 'STOCK'">
                <div class="modal-contentt form-container">
                  <div class="modal-header">
                    <div style="align-items: center; width: 150px;">
                      <label for="subtype">Sub Type:</label>
                      <select id="subtype" class="form-control" v-model="subType" reuqired>
                        <option v-for="subtype in subtypes" :key="subtype.value" :value="subtype.value">
                          {{ subtype.label }}
                        </option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px">
                      <label for="department">Department:</label>
                      <select
                          id="department"
                          class="form-control"
                          v-model="selectedDepartment"
                          @change="fetchData"
                          required
                      >
                        <option disabled value="">Select Department</option>
                        <option v-for="dept in allDepartments" :key="dept.id" :value="dept.name">
                          {{ dept.name }}
                        </option>
                      </select>
                    </div>
                    <div style="align-items: center; margin-left: 10px">
                      <label for="purchase_orders">Purchase Orders:</label>
                      <v-select
                          :options="purchaseOrders"
                          v-model="orders"
                          :reduce="po=>po.orderNum"
                          label="orderNum" required
                      ></v-select>
                    </div>
                  </div>

                  <div class="modal-bodyy">
                    <div
                        class="cardi col-md-4"
                        v-for="(item, index) in usersByDepartment"
                        :key="index"
                    >
                      <div class="cntr">
                        <label>
                          <input
                              type="checkbox"
                              :value="item.id"
                              @change="toggleUserSelection(item)"
                          />
                          Select
                        </label>
                      </div>
                      <!--            <p style="font-weight: 600; padding: 10px">Bwezani Kanyimbi</p>-->
                      <input type="text" name="text" class="input" placeholder="Name" v-model="item.Username" disabled>
                      <div class="mob">
                        <input
                            type="text"
                            class="input"
                            placeholder="Number"
                            v-model="item.phone_number"
                        />
                        <div>
                          <select
                              id="paymenttype"
                              class="form-control"
                              :value="getUserField(item.id, 'provider')"
                              @change="updateUserField(item.id, 'provider', $event.target.value)"

                          >
                            <option disabled value="">Account Type</option>
                            <option v-for="paymenttype in paymentTypes" :key="paymenttype" :value="paymenttype">
                              {{ paymenttype }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <ApproveButton
                        button-text="Process"
                        hoverTextColor="#ffffff"
                        @click="validateFormToSend"
                    />
                    <ApproveButton
                        button-text="Close"
                        hoverColor="#c82333"
                        hoverTextColor="#ffffff"
                        @click="closeBatchModal"
                    />
                  </div>
                  <div v-if="isLoading" class="overlay">
                    <section class="dots-container">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="overlay">
      <section class="dots-container">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </section>
    </div>
<!--    <button @click="check">CHECK</button>-->
  </div>
</template>
<script>
import FloatingAddButton from "@/components/layout/utils/FloatingAddButton.vue";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';
import {Storage} from "@/Services/Storage";
import {v4 as uuidv4} from 'uuid';
import Swal from "sweetalert2";
import ApproveButton from "@/components/buttons/ApproveButton.vue";
import vuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { Contacts } from '@capacitor-community/contacts';
import { Capacitor } from '@capacitor/core';
import reportsImage from "@/assets/img/reports.jpg";

const CARRIER_PREFIXES = {
  AIRTEL_DEPOSIT: ['097', '077', '057'],
  AIRTEL: ['097', '077', '057'],
  MTN_DEPOSIT: ['096', '076'],
  MTN: ['096', '076'],
  ZAMTEL_DEPOSIT: ['095', '075'],
  ZAMTEL: ['095', '075']
};

const CARRIER_PAYMENT_TYPES = Object.keys(CARRIER_PREFIXES);

const toLocalNumber = (value = '') => (value || '').toString()
    .replace(/^\+?260/, '0')
    .replace(/[^\d]/g, '');

export default {
  name: "wallet",
  components: {
    ApproveButton,
    FloatingAddButton,
    vSelect,
    vuePhoneNumberInput
  },
  created() {
    this.getDepartments();
    // this.getRequestTypes();
  },
  beforeMount() {
    this.getDepartments();
    this.fetchPaymentTypes();
    this.initializeData();
    this.storeSelectedWallet();
  },
  data() {
    return {
      userDept: null,
      carrier: false,
      loading: false,
      defaultRequestTypeImage: reportsImage,
      nameType: null,
      options: {},
      imageSrc: null,
      allRequestTypes: [],
      number: '',
      isLoading: false,
      updatedFormDataList: '',
      selectedDepartment: '',
      allDepartments: '',
      orders: '',
      timeWorked: '',
      jobCards: '',
      department: "Developer",
      subType: '',
      reason: '',
      selectedUsers: [],
      usersByDepartment: [],
      items: '',
      batchModalVisible: false,
      wallets: [], // Initialize with an empty array
      selectedWallet: '',
      subtypes: [], // New data property for subtypes
      ASSET: "ASSET",
      BUNDLE: "BUNDLE",
      JOBCARD: "JOBCARD",
      STOCK: "STOCK",
      EXPENSE: "EXPENSE",
      OVERTIME: "OVERTIME",
      SHIPPING: "SHIPPING",
      user: {
        Username: 'Null',
        id: 'Null',
        office: ''
      },
      purchaseOrders: [],
      imageOptions: [],
      cards: [
        {image: 'asset_i.jpg', name: 'ASSET'},
        {image: 'jobcard.png', name: 'BUNDLE'},
        {image: 'expense.jpg', name: 'EXPENSE'},
        {image: 'jobcard.webp', name: 'JOBCARD'},
        {image: 'overtime.jpg', name: 'OVERTIME'},
        {image: 'stock.jpg', name: 'STOCK'},
        {image: 'reports.jpg', name: 'REPORTS'}
      ],
      cardss: [
        {image: 'asset_i.jpg', name: 'ASSET'},
        {image: 'bundle_i.jpg', name: 'BUNDLE'},
        {image: 'expense.jpg', name: 'EXPENSE'},
        {image: 'jobcard.webp', name: 'JOBCARD'},
        {image: 'overtime.jpg', name: 'OVERTIME'},
        {image: 'stock.jpg', name: 'STOCK'},
        {image: 'stock_i.jpg', name: 'REPORTS'}
      ],
      showModal: false,
      modalTitle: '',
      selectedCard: null,
      subtype: '',
      formData: {},
      paymentTypes: [], // New data property for payment types
      suppliers: [],    // Shipping: supplier list from burntofi_chrilan.supplier
      stores: [],       // Shipping: store list from burntofi_chrilan.store
      invoices: [],     // Shipping: invoices from burntofi_chrilan.consignment_invoices
      useInvoiceAttachment: false,
      jobCard: [],
      expenseCategories: [],
      accountTypes: [],
      jobCardOptions: [], // Assuming you have job card types
      isMobile: window.innerWidth <= 768,
      searchTerm: '',
      contactModalVisible: false,
      contactOptions: [],
      contactSearch: '',
    };
  },
  computed: {
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
    filteredTypes() {
      return this.allRequestTypes.filter((item) =>
          item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    filteredInvoices() {
      const selectedStoreId = this.formData?.storeId;
      if (!selectedStoreId) return this.invoices;

      return this.invoices.filter((invoice) => {
        const invoiceStoreId = invoice?.storeId ?? invoice?.store_id ?? invoice?.StoreId ?? invoice?.store;
        return !invoiceStoreId || `${invoiceStoreId}` === `${selectedStoreId}`;
      });
    },
    canUseContactPicker() {
      const hasPlugin = !!(Contacts && typeof Contacts.getContacts === 'function');
      const hasNavigatorPicker = typeof navigator !== 'undefined' && !!(navigator?.contacts?.select);
      return hasNavigatorPicker || hasPlugin;
    },
    isNativePlatform() {
      return Capacitor?.getPlatform?.() !== 'web';
    },
    filteredContactOptions() {
      const term = (this.contactSearch || '').toLowerCase();
      if (!term) return this.contactOptions;
      return this.contactOptions.filter(opt =>
          (opt.name || '').toLowerCase().includes(term) ||
          (opt.raw || '').toLowerCase().includes(term) ||
          (opt.local || '').toLowerCase().includes(term)
      );
    }
  },
  watch: {
    'formData.paymenttype': function(newValue) {
      this.carrier = this.isCarrierPaymentType(newValue);
    },
    'formData.storeId': function() {
      if (!this.options?.options?.hasInvoice) return;
      const stillValid = this.filteredInvoices.some(
          invoice => `${this.getInvoiceValue(invoice)}` === `${this.formData?.invoiceId ?? ''}`
      );
      if (!stillValid) {
        this.formData.invoiceId = null;
      }
    },
    // 'formData.number': function(newValue) {
    //   // Only trigger validation if the payment type is one of the valid carriers
    //   const validPaymentTypes = ['AIRTEL_DEPOSIT', 'MTN_DEPOSIT', 'ZAMTEL_DEPOSIT'];
    //   const selectedCarrier = this.formData.paymenttype;
    //
    //   if (!validPaymentTypes.includes(selectedCarrier)) return; // Don't trigger validation for other payment types
    //
    //   // Wait until the length of the input is 10 characters before validating
    //   if (newValue.length < 10) return;
    //
    //   // Define the valid prefixes based on the selected carrier
    //   const carrierPrefixes = {
    //     AIRTEL_DEPOSIT: ['097', '077'],
    //     MTN_DEPOSIT: ['096', '076'],
    //     ZAMTEL_DEPOSIT: ['095', '075']
    //   };
    //
    //   const validPrefixes = carrierPrefixes[selectedCarrier] || [];
    //
    //   // Clean up the input number by removing non-digit characters
    //   const localNumber = newValue.replace(/[^\d]/g, '');
    //
    //   // Check if the number matches the valid prefix
    //   const isValid = validPrefixes.some(prefix => localNumber.startsWith(prefix));
    //
    //   if (!isValid && newValue) {
    //     // If the number is not valid, show a warning and clear the input
    //     this.formData.number = ''; // Clear the invalid input
    //     Swal.fire({
    //       icon: 'warning',
    //       title: 'Invalid Number Format',
    //       text: `The number you entered doesn't match the required format for ${selectedCarrier.replace('_DEPOSIT', '')}.`,
    //       confirmButtonText: 'Okay'
    //     });
    //   }
    // },
    'formData.number': function(newValue) {
      const selectedCarrier = this.formData.paymenttype;
      if (!this.isCarrierPaymentType(selectedCarrier)) return;

      const rawNumber = typeof newValue === 'string' ? newValue : newValue?.phoneNumber ?? '';
      let localNumber = toLocalNumber(rawNumber);

      if (localNumber.length === 9 && /^[7-9]/.test(localNumber)) {
        const corrected = '0' + localNumber;
        if (this.formData.number !== corrected) {
          this.formData.number = corrected;
        }
        localNumber = corrected;
      }

      const validPrefixes = this.getCarrierPrefixes(selectedCarrier);
      const prefix = localNumber.slice(0, 3);
      if (prefix.length >= 3 && !this.isPrefixValid(localNumber, validPrefixes)) {
        this.formData.number = '';
        this.showInvalidPrefixAlert(prefix, validPrefixes, selectedCarrier);
        return;
      }
    },
    'formData.amount': function (newValue) {
      if (newValue === null || newValue === '' || typeof newValue === 'undefined') return;

      const amount = parseFloat(newValue);

      if (isNaN(amount) || amount <= 0) {
        this.formData.amount = ''; // Clear the invalid input
        Swal.fire({
          icon: 'warning',
          title: 'Invalid Amount',
          text: 'Amount must be greater than zero.',
          confirmButtonText: 'Okay'
        });
      }
    }
  },
  methods: {
    getSupplierValue(supplier) {
      return supplier?.SuppCode ?? supplier?.supplierCode ?? supplier?.id ?? supplier?.code ?? null;
    },
    getStoreValue(store) {
      return store?.store_id ?? store?.storeId ?? store?.id ?? null;
    },
    getInvoiceValue(invoice) {
      return invoice?.id ?? invoice?.invoiceId ?? invoice?.invoiceNumber ?? null;
    },
    isCarrierPaymentType(type) {
      return CARRIER_PAYMENT_TYPES.includes(type);
    },
    getCarrierPrefixes(type) {
      return CARRIER_PREFIXES[type] || [];
    },
    isPrefixValid(localNumber, validPrefixes) {
      return validPrefixes.some(prefix => localNumber.startsWith(prefix));
    },
    getCarrierLabel(carrierType) {
      return (carrierType || '').replace('_DEPOSIT', '') || 'selected carrier';
    },
    getContactNumbers(contact) {
      const collected = [];
      const addNumber = (val) => {
        if (!val) return;
        if (Array.isArray(val)) return val.forEach(addNumber);
        if (typeof val === 'string' || typeof val === 'number') {
          collected.push(val.toString());
          return;
        }
        if (typeof val === 'object') {
          addNumber(val.number || val.value);
          addNumber(val.tel);
          addNumber(val.phoneNumbers);
        }
      };
      addNumber(contact?.tel);
      addNumber(contact?.phoneNumbers);
      return collected;
    },
    showInvalidPrefixAlert(prefix, validPrefixes, carrierType) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Number Format',
        text: `Prefix "${prefix}" does not match ${this.getCarrierLabel(carrierType)}. Valid prefixes: ${validPrefixes.join(', ')}`,
        confirmButtonText: 'Okay'
      });
    },
    async pickContact() {
      if (!this.carrier || !this.isCarrierPaymentType(this.formData.paymenttype)) {
        return Swal.fire({
          icon: 'info',
          title: 'Select Account Type',
          text: 'Choose Airtel, MTN, or Zamtel first to filter contacts by the right prefixes.'
        });
      }

      const hasPlugin = !!(Contacts && typeof Contacts.getContacts === 'function');
      const hasNavigatorPicker = typeof navigator !== 'undefined' && !!(navigator?.contacts?.select);

      if (!hasPlugin && !hasNavigatorPicker) {
        return Swal.fire({
          icon: 'info',
          title: 'Contact Picker Not Available',
          text: 'Contacts not available in this browser/device. Use a supported mobile build or browser contact picker.'
        });
      }

      try {
        const validPrefixes = this.getCarrierPrefixes(this.formData.paymenttype);

        // Prefer browser picker when available
        if (hasNavigatorPicker) {
          const contacts = await navigator.contacts.select(['name', 'tel'], {multiple: false});
          if (!contacts || !contacts.length) return;

          const pickableNumbers = [];
          contacts.forEach(contact => this.getContactNumbers(contact).forEach(num => pickableNumbers.push(num)));

          const matchingNumber = pickableNumbers
              .map(num => toLocalNumber(num))
              .find(num => this.isPrefixValid(num, validPrefixes));

          if (!matchingNumber) {
            const detectedNumbers = pickableNumbers
                .filter(Boolean)
                .map(num => (num?.number || num?.value || num || '').toString().trim())
                .filter(Boolean);
            return Swal.fire({
              icon: 'warning',
              title: 'No Matching Number',
              text: `Selected contact has no number with prefixes: ${validPrefixes.join(', ')}. Detected (raw): ${detectedNumbers.length ? detectedNumbers.join(', ') : 'none'}`
            });
          }

          this.formData.number = matchingNumber;
          this.number = matchingNumber;
        } else if (hasPlugin) {
          this.contactOptions = [];
          this.contactSearch = '';
          const { contacts } = await Contacts.getContacts();
          if (!contacts || !contacts.length) {
            return Swal.fire({
              icon: 'info',
              title: 'No Contacts Found',
              text: 'No contacts were returned from the device.'
            });
          }

          const options = [];

          contacts.forEach(contact => {
            const name = contact?.name || contact?.displayName || contact?.givenName || contact?.familyName || 'Unknown';
            this.getContactNumbers(contact).forEach(raw => {
              const local = toLocalNumber(raw);
              if (this.isPrefixValid(local, validPrefixes)) {
                options.push({
                  name,
                  raw: raw.toString(),
                  local
                });
              }
            });
          });

          this.contactOptions = options;
          this.contactModalVisible = true;

          if (!options.length) {
            this.contactModalVisible = false;
            const detectedNumbers = contacts
                .flatMap(c => this.getContactNumbers(c))
                .filter(Boolean)
                .map(num => (num?.number || num?.value || num || '').toString().trim())
                .filter(Boolean);
            return Swal.fire({
              icon: 'warning',
              title: 'No Matching Number',
              text: `Contacts found, but none with prefixes: ${validPrefixes.join(', ')}. Detected (raw): ${detectedNumbers.length ? detectedNumbers.join(', ') : 'none'}`
            });
          }
        }
      } catch (error) {
        console.error('Contact pick failed', error);
        Swal.fire({
          icon: 'error',
          title: 'Contact Selection Failed',
          text: 'Unable to fetch contacts on this device. Ensure contacts permission is granted.'
        });
      }
    },
    selectContact(option) {
      if (!option) return;
      this.formData.number = option.local || option.raw || '';
      this.number = option.local || option.raw || '';
      this.contactModalVisible = false;
    },
    closeContactModal() {
      this.contactModalVisible = false;
    },
    check() {
      console.log(this.curUser);
    },
    handlePaste(event) {
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      const selectedCarrier = this.formData.paymenttype;
      if (!this.isCarrierPaymentType(selectedCarrier)) return;

      const localNumber = toLocalNumber(pastedText);
      const prefix = localNumber.slice(0, 3);
      const validPrefixes = this.getCarrierPrefixes(selectedCarrier);
      const isValid = this.isPrefixValid(localNumber, validPrefixes);

      if (prefix.length >= 3 && !isValid) {
        event.preventDefault(); // Cancel the paste
        this.showInvalidPrefixAlert(prefix, validPrefixes, selectedCarrier);
        return;
      }

      // If paste is valid, manually trigger validation after paste
      this.$nextTick(() => {
        this.validateCarrier({ phoneNumber: pastedText });
      });
    },

    validateCarrier(value) {
      const selectedCarrier = this.formData.paymenttype;
      if (!this.isCarrierPaymentType(selectedCarrier)) return;

      const localNumber = toLocalNumber(value?.phoneNumber || '');
      const prefix = localNumber.slice(0, 3);
      const validPrefixes = this.getCarrierPrefixes(selectedCarrier);

      if (prefix.length < 3 || !validPrefixes.length) return;

      const isValid = this.isPrefixValid(localNumber, validPrefixes);

      if (!isValid) {
        this.formData.paymenttype = ''; // Reset payment type
        this.showInvalidPrefixAlert(prefix, validPrefixes, selectedCarrier);
      }
    },


    updateNumber (event) {
      this.isValidNum = event.isValid
      let contact = event.formattedNumber.replaceAll('+','')
      this.number = contact;
      console.log({contact})
      this.fieldsets[0].inputs[3].value = contact;
    },
    getRequestTypeImageUrl(requestTypeId) {
      return `${ticketApi2}requests/${requestTypeId}/image`;
    },
    attachImagesToItems() {
      // Use fallback image for Shipping Expense
      const shippingImg = 'https://media.lordicon.com/icons/wired/flat/757-delivery.gif';
      this.allRequestTypes = this.allRequestTypes.map(item => {
        const fallback = (item.name === 'Request Shipping' || item.name === 'Shipping Expense') ? shippingImg : this.getRequestTypeImageUrl(item.id);
        return {
          ...item,
          image: fallback
        };
      });
    },
    onRequestTypeImageError(event) {
      if (!event?.target) return;
      if (event.target.dataset.fallbackApplied === "1") return;
      event.target.dataset.fallbackApplied = "1";
      event.target.src = this.defaultRequestTypeImage;
    },
    async getUserDept() {
      // this.$utils.showLoading()
      try {
        const response = await axios.get(`${synergyApi}employee/department-by-username/${this.user.username}`);
        this.userDept = response.data;
        await this.getRequestTypes();
        // console.log(this.userDept);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        // this.$utils.hideLoading();
      }
    },
    async getRequestTypes() {
      this.loading = true;
      // this.$utils.showLoading()
      try {
        const response = await axios.get(`${ticketApi2}requests/request_types?departmentId=${this.userDept.id}`);
        this.allRequestTypes = response.data;

        // Rename "Request Shipping" → "Shipping Expense" and reposition after "Site Expenses"
        const shippingIdx = this.allRequestTypes.findIndex(t => t.name === 'Request Shipping');
        if (shippingIdx !== -1) {
          this.allRequestTypes[shippingIdx].name = 'Shipping Expense';
          const [shippingCard] = this.allRequestTypes.splice(shippingIdx, 1);
          const siteIdx = this.allRequestTypes.findIndex(t => t.name === 'Site Expenses');
          if (siteIdx !== -1) {
            this.allRequestTypes.splice(siteIdx + 1, 0, shippingCard);
          } else {
            this.allRequestTypes.push(shippingCard);
          }
        } else if (!this.allRequestTypes.some(t => t.name === 'Shipping Expense')) {
          const siteIdx = this.allRequestTypes.findIndex(t => t.name === 'Site Expenses');
          const shippingCard = {
            id: 45,
            name: 'Shipping Expense',
            image: 'https://media.lordicon.com/icons/wired/flat/757-delivery.gif'
          };
          if (siteIdx !== -1) {
            this.allRequestTypes.splice(siteIdx + 1, 0, shippingCard);
          } else {
            this.allRequestTypes.push(shippingCard);
          }
        }

        this.attachImagesToItems();
        console.log('THIS IS  THE DATA', this.allRequestTypes);
      } catch (error) {
        await errorHandler.tomcatError(error);
      } finally {
        this.loading = false;
        // this.$utils.hideLoading();
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    getDepartments() {
      axios.get(synergyApi + 'employee/getAllDepartments')
          .then(response => {
            this.allDepartments = response.data;
          })
          .catch(error => {
            console.error('Error fetching allDepartments:', error);
          });
    },
    toggleUserSelection(user) {
      const index = this.selectedUsers.findIndex((u) => u.id === user.id);
      if (index === -1) {
        // Add user if checkbox is checked
        this.selectedUsers.push({...user, amount: null, paymenttype: ""});
      } else {
        // Remove user if checkbox is unchecked
        this.selectedUsers.splice(index, 1);
      }
    },
    getUserField(userId, field) {
      const user = this.selectedUsers.find((u) => u.id === userId);
      return user ? user[field] : "";
    },
    updateUserField(userId, field, value) {
      const user = this.selectedUsers.find((u) => u.id === userId);
      if (user) {
        user[field] = value;
      }
    },
    async fetchData() {
      let department = this.selectedDepartment;
      console.log("Selected Department:", department);  // Debug line
      if (!department) {
        console.warn("No department selected!");
        return;
      }

      try {
        const response = await axios.get(synergyApi + `employee/getEmployeesByDepartment?Type=${department}`);
        this.usersByDepartment = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    showBatchModal() {
      this.batchModalVisible = true;
    },
    closeBatchModal() {
      this.batchModalVisible = false;
    },
    storeSelectedWallet() {
      if (this.selectedWallet) {
        // localStorage.setItem('selectedWallet', this.selectedWallet);
        this.$store.commit(`setSelectedWallet`, this.selectedWallet)
      }
    },
    navigate(card) {
      if (card.name === 'REPORTS') {
        this.$router.push({name: 'UserRequests'});
      } else {
        this.getOptions(card)
      }
    },
    async getOptions(card) {
      if (card.name === 'Shipping Expense') {
        this.options = {
          options: {
            hasSupplier: true,
            hasStore: false,
            hasInvoice: true,
            hasTime: false,
            hasPurchaseOrder: false,
            hasImageId: false,
            hasJobCardHeaderId: false,
          }
        };
        this.openModal(card);
        return;
      }
      this.$utils.showLoading()
      try {
        const response = await axios.get(ticketApi2 + `requests/${card.id}`);
        this.options = response.data;
        console.log(this.options)
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.$utils.hideLoading();
        this.openModal(card);
      }
    },
    async fetchPaymentTypes() {
      try {
        const response = await axios.get(ticketApi2 + 'payment-types');
        this.paymentTypes = response.data;
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
    async initializeData() {
      // this.fetchJobcards()
      await this.getLoggedInUser();
      await this.getwallets();
      this.fetchPurchaseOrders()
      // this.fetchJobcards()
      this.fetchAccountTypes();
      console.log('Account Types:', this.accountTypes); // Check if this logs the expected data
      this.fetchPurchaseOrders();
    },
    async getLoggedInUser() {
      this.user = await Storage.getCurrentUser();
      await this.getUserDept();
      console.log(this.user);
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        this.wallets = response.data;
        console.log('Wallets:', this.wallets);

        // Set the first wallet as the default selected wallet
        if (this.wallets.length > 0) {
          this.selectedWallet = this.wallets[0].id;
        }
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.storeSelectedWallet();
        this.$utils.hideLoading();
      }
    },
    openModal(card) {
      this.nameType = card.name;
      this.selectedCard = card;
      this.modalTitle = `${card.name} Money Request`;
      this.showModal = true;
      this.resetFormData();
      if (card.name === 'Shipping Expense') {
        this.fetchSuppliers();
      }
      this.fetchTypesByCategory(card);
    },
    async fetchTypesByCategory(card) {
      try {
        const response = await axios.get(ticketApi2 + `requests/types/${card.id}/subcategories`);
        // Transform the response into the format your dropdown expects
        this.subtypes = response.data
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
    // async fetchTypesByCategory(category) {
    //   try {
    //     const response = await axios.get(ticketApi2 + `getSubTypes/${category}`);
    //     // Transform the response into the format your dropdown expects
    //     this.subtypes = response.data.map(type => ({
    //       value: type,
    //       label: type
    //     }));
    //   } catch (error) {
    //     return errorHandler.tomcatError(error)
    //   }
    // },
    async fetchSuppliers() {
      try {
        const response = await axios.get(ticketApi2 + 'suppliers');
        this.suppliers = response.data;
      } catch (error) {
        this.suppliers = [];
      }
    },
    async fetchStores() {
      try {
        const response = await axios.get(ticketApi2 + 'stores');
        this.stores = response.data;
      } catch (error) {
        this.stores = [];
      }
    },
    async fetchInvoices(supplierCode) {
      try {
        const response = await axios.get(ticketApi2 + `invoices?supplier=${supplierCode}`);
        this.invoices = response.data;
      } catch (error) {
        this.invoices = [];
      }
    },
    onSupplierChange(supplierCode) {
      if (supplierCode) {
        this.formData.invoiceId = null;
        this.fetchInvoices(supplierCode);
      } else {
        this.invoices = [];
        this.formData.invoiceId = null;
      }
    },
    closeModal() {
      this.showModal = false;
      this.selectedCard = null;
      this.modalTitle = '';
      this.contactModalVisible = false;
      this.contactOptions = [];
      this.invoices = [];
      this.useInvoiceAttachment = false;
    },
    resetFormData() {
      this.formData = {};
    },
    validateShippingFields() {
      if (this.nameType !== 'Shipping Expense') return true;

      const shippingRequirements = [
        { field: 'supplier', label: 'supplier' },
        { field: 'paymenttype', label: 'account type' },
        { field: 'number', label: 'account number' },
        { field: 'amount', label: 'amount' },
      ];

      const missingField = shippingRequirements.find(({ field }) =>
        !this.formData?.[field]
      );
      if (missingField) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Required Field',
          text: `Please provide the ${missingField.label} before submitting this shipping request.`,
          confirmButtonText: 'OK'
        });
        return false;
      }

      const amount = Number(this.formData.amount);
      if (!Number.isFinite(amount) || amount <= 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid Amount',
          text: 'Shipping amount must be greater than zero.',
          confirmButtonText: 'OK'
        });
        return false;
      }

      return true;
    },
    validateFormToSend() {

      console.log('WE ARE IN ASSET');
      const localId = uuidv4();
      this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
        // Find the corresponding user in usersByDepartment using the ID
        const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
        // Ensure each object gets its own unique, updated number
        return {
          ...selectedUser,
          wallet: this.selectedWallet ?? null,
          type: this.nameType ?? null,
          requestUser: this.user?.username ?? null,
          subType: this.formData?.subtype ?? null,
          reason: this.reason ?? null,
          department: this.department ?? null,
          reference: updatedUser?.phone_number ?? selectedUser?.phone_number ?? null,
          localId: uuidv4(),
          ticketNumber: this.jobCard ?? null,
          time: this.timeWorked ?? null,
          purchaseOrder: this.jobCards ?? null,
        };

      });
      console.log(this.updatedFormDataList);
      this.submitAllSelectedRequests();

      if (this.selectedCard.name === 'ASSET') {
        console.log('WE ARE IN ASSET');
        const localId = uuidv4();
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          // Find the corresponding user in usersByDepartment using the ID
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          // Ensure each object gets its own unique, updated number
          return {
            ...selectedUser,
            wallet: this.selectedWallet,
            type: this.ASSET,
            requestUser: this.user.username,
            subType: this.subType,
            reason: this.reason,
            department: this.department,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number,
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        return this.submitAllSelectedRequests();

      } else if (this.selectedCard.name === 'BUNDLE') {
        const localId = uuidv4();
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          // Find the corresponding user in usersByDepartment using the ID
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          // Ensure each object gets its own unique, updated number
          return {
            ...selectedUser,
            wallet: this.selectedWallet,
            type: this.BUNDLE,
            requestUser: this.user.username,
            subType: this.subType,
            department: this.department,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number,
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        console.log('WE ARE IN BUNDLE');
        return this.submitAllSelectedRequests();

      } else if (this.selectedCard.name === 'EXPENSE') {
        const localId = uuidv4();
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          // Find the corresponding user in usersByDepartment using the ID
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          // Ensure each object gets its own unique, updated number
          return {
            ...selectedUser,
            wallet: this.selectedWallet,
            type: this.EXPENSE,
            requestUser: this.user.username,
            subType: this.subType,
            reason: this.reason,
            department: this.department,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number,
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        console.log('WE ARE IN EXPENSE');
        return this.submitAllSelectedRequests();

      } else if (this.selectedCard.name === 'JOBCARD') {
        const localId = uuidv4();
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          // Find the corresponding user in usersByDepartment using the ID
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          // Ensure each object gets its own unique, updated number
          return {
            ...selectedUser,
            wallet: this.selectedWallet,
            ticketNumber: this.jobCard,
            type: this.JOBCARD,
            requestUser: this.user.username,
            subType: this.subType,
            reason: this.reason,
            department: this.department,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number,
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        console.log('WE ARE IN JOBCARD');
        return this.submitAllSelectedRequests();

      } else if (this.selectedCard.name === 'OVERTIME') {
        const localId = uuidv4();
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          // Find the corresponding user in usersByDepartment using the ID
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          // Ensure each object gets its own unique, updated number
          return {
            ...selectedUser,
            time: this.timeWorked,
            purchaseOrder: this.jobCards,
            wallet: this.selectedWallet,
            type: this.OVERTIME,
            requestUser: this.user.username,
            subType: this.subType,
            reason: this.reason,
            department: this.selectedDepartment,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number, // Reference should also be unique
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        console.log('WE ARE IN OVERTIME');
        return this.submitAllSelectedRequests();

      } else if (this.selectedCard.name === 'STOCK') {
        const localId = uuidv4();
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          // Find the corresponding user in usersByDepartment using the ID
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          // Ensure each object gets its own unique, updated number
          return {
            ...selectedUser,
            purchaseOrder: this.orders,
            wallet: this.selectedWallet,
            type: this.STOCK,
            requestUser: this.user.username,
            subType: this.subType,
            department: this.department,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number,
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        console.log('WE ARE IN STOCK');
        return this.submitAllSelectedRequests();

      } else if (this.selectedCard.name === 'Shipping Expense') {
        this.updatedFormDataList = this.selectedUsers.map(selectedUser => {
          const updatedUser = this.usersByDepartment.find(user => user.id === selectedUser.id);
          return {
            ...selectedUser,
            wallet: this.selectedWallet,
            type: 'Request Shipping',
            // FIX 2026-05-08: subType must match request_subcategories table name
            subType: 'Supplier Transport',
            requestUser: this.user.username,
            reason: this.formData?.reason ?? null,
            department: this.department,
            reference: updatedUser ? updatedUser.phone_number : selectedUser.phone_number,
            paymenttype: this.formData?.paymenttype ?? null,
            number: this.formData?.number ?? null,
            amount: this.formData?.amount ?? null,
            supplier: this.formData?.supplier ?? null,
            supplierId: this.formData?.supplier ?? null,
            localId: uuidv4(),
          };
        });
        console.log(this.updatedFormDataList);
        console.log('WE ARE IN SHIPPING');
        return this.submitAllSelectedRequests();
      }
    },
    async submitAllSelectedRequests() {
      this.updatedFormDataList.forEach(data => {
        delete data.id;
        delete data.paymenttype;
        delete data.phone_number;
        delete data.ticketNumber;
        delete data.Username;
      });
      console.log(this.updatedFormDataList)
      if (this.selectedUsers.length === 0) {
        console.warn("No users selected for submission.");
        return;
      }
      this.isLoading = true;
      const requests = this.updatedFormDataList.map(userData =>
          axios.post(ticketApi2 + 'transaction-handler/user-request', userData)
      );

      try {
        const responses = await Promise.all(requests);
        console.log("All requests submitted successfully:", responses);
        this.isLoading = false;
        Swal.fire({
          title: 'Success!',
          text: 'Requests sent successfully.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
        // Track form submit
        if (window.usageTracker) {
          window.usageTracker.track('petty-cash', {
            feature: 'form:request-send',
            action: 'submit'
          });
        }
        window.location.reload();
        this.selectedUsers = [];
        this.updatedFormDataList = [];
      } catch (error) {
        this.isLoading = false;
        errorHandler.tomcatError(error);
      }
    },

    async submitForm() {
      if (!this.validateShippingFields()) {
        return;
      }

      const rawNumber = this.formData?.number ?? '';
      let cleanedNumber = rawNumber.replace(/[^\d]/g, '');
      // GINGER-20260503: Remove leading 0 after 260 - +260 0975206308 → 260975206308
      // TICKET: #23160 — Phone number field uses 14 characters instead of 13
      if (cleanedNumber.startsWith('2600')) {
        cleanedNumber = '260' + cleanedNumber.substring(4);
      }

      if (cleanedNumber.length < 10) {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid Number',
          text: 'Please enter a valid phone number with 10 digits.',
          confirmButtonText: 'OK'
        });
        return;
      }

      this.formData.number = cleanedNumber;
      const apiEndpoint = ticketApi2 + 'transaction-handler/user-request';
      const localId = uuidv4();
      let dataToSend = {localId};
      let submissionAttempted = false;

      dataToSend = {
        ...dataToSend,
        // FIX 2026-05-04: Convert "Shipping Expense" to "Request Shipping" to match request_types table
        type: this.nameType === 'Shipping Expense' ? 'Request Shipping' : (this.nameType ?? null),
        wallet: this.selectedWallet ?? null,
        requestUser: this.user?.username ?? null,
        // FIX 2026-04-01: was this.curUser.role (sends user type like "Developer" instead of
        // actual department name). userDept is fetched from /employee/department-by-username/.
        // REVERT: change back to this.curUser.role
        department: this.userDept?.name || this.curUser.role,
        reason: this.formData?.reason ?? null,
        amount: this.formData?.amount ?? null,
        reference: this.formData?.number ?? null,
        provider: this.formData?.paymenttype ?? null,
        // FIX 2026-05-08: Convert "Request Shipping" subtype to "Supplier Transport" to match request_subcategories table
        subType: (this.nameType === 'Shipping Expense' && this.formData?.subtype === 'Request Shipping')
          ? 'Supplier Transport' : (this.formData?.subtype ?? null),
        imageBase64Str: this.formData?.image ?? null,
        purchaseOrder: this.formData?.jobCard ?? null,
        time: this.formData?.night_or_weekend ?? null,
        supplier: this.formData?.supplier ?? null,
        storeId: this.formData?.storeId ?? null,
        invoiceId: this.formData?.invoiceNumber ?? this.formData?.invoiceId ?? null,
      };

      console.log(dataToSend)
      console.warn('IN THE SUBMIT METHOD')

      try {
        if (this.shouldVerifyDepositAccount()) {
          await this.verifyAccountNumber(cleanedNumber);
        }
        submissionAttempted = true;
        this.$utils.showLoading();
        const response = await axios.post(apiEndpoint, dataToSend);
        console.log('Form submitted successfully:', response.data);
        Swal.fire({
          title: 'Success!',
          text: 'Request approved successfully.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
        // Track form submit
        if (window.usageTracker) {
          window.usageTracker.track('petty-cash', {
            feature: 'form:request-approve',
            action: 'submit'
          });
        }
        this.closeModal();
        this.formData = {};
        window.location.reload();
      } catch (error) {
        if (error?.__isVerificationError) {
          return;
        }
        errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    handleWeekendChange() {
      this.updateAmount();
    },
    handleTimeWorkedChange() {
      this.updateAmount();
    },
    updateAmount() {
      if (this.selectedCard.name === 'OVERTIME') {
        // Check if it's a weekend and time worked is less than 5 hours
        if (this.formData.night_or_weekend === 'Weekend' && this.formData.time_worked < 5) {
          this.formData.amount = 200;
        } else if (this.formData.time_worked >= 6) {
          this.formData.amount = 200;
        } else {
          this.formData.amount = 75;
        }
      }
    },

    fetchAccountTypes() {
      axios.get(ticketApi2 + 'getTypes')
          .then(response => {
            // Ensure response.data is in the expected format
            this.accountTypes = response.data.map(type => ({
              id: type.id, // Ensure these keys match your response
              name: type.name
            }));
          })
          .catch(error => {
            return errorHandler.tomcatError(error);
          });
    },
    async fetchJobcards(query) {
      try {
        // Make an API request to fetch job card options based on the query
        const response = await axios.get(ticketApi + `ticket/basicSearch?search=${query}`);
        this.jobCardOptions = response.data;  // Update jobCardOptions with filtered data
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },
    fetchPurchaseOrders() {
      axios.get(backOfficeApi + 'purchaseOrder/burntofi_chrilan/getApprovedPOs')
          .then(response => {
            this.purchaseOrders = response.data
          })
          .catch(error => errorHandler.tomcatError(error));
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.formData.image = reader.result; // Store the Base64 string in formData
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
    shouldVerifyDepositAccount() {
      return ['AIRTEL_DEPOSIT', 'ZAMTEL_DEPOSIT'].includes(this.formData?.paymenttype);
    },
    async verifyAccountNumber(cell) {
      try {
        const {data} = await axios.get('https://lna.pos.co.zm/kazangApi/api/getMobileUserInfo', {params: {cell}});
        const status = (data?.status ?? data?.Status ?? data?.code ?? data?.Code ?? data?.Response ?? '').toString().toLowerCase();
        const successStates = ['','success','00','0','200'];
        const isSuccess = successStates.includes(status);
        if (!isSuccess) {
          const message = data?.message ?? data?.Message ?? 'Account verification failed.';
          const err = new Error(message);
          err.__isVerificationError = true;
          throw err;
        }

        const firstName = data?.customerFirstName ?? data?.CustomerFirstName ?? '';
        const lastName = data?.customerLastName ?? data?.CustomerLastName ?? '';
        const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

        const confirmResult = await Swal.fire({
          title: 'Confirm Account Details',
          text: fullName ? `Is this the correct account holder: ${fullName}?` : 'Proceed with the retrieved account details?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, continue',
          cancelButtonText: 'No, cancel'
        });

        if (!confirmResult.isConfirmed) {
          const err = new Error('Account verification cancelled by user.');
          err.__isVerificationError = true;
          throw err;
        }

        return data;
      } catch (error) {
        const message = error.response?.data?.message ?? error.message ?? 'Unable to verify account number. Please try again.';
        Swal.fire({
          icon: 'error',
          title: 'Account Verification Failed',
          text: message,
          confirmButtonText: 'OK'
        });
        const err = error instanceof Error ? error : new Error(message);
        err.__isVerificationError = true;
        throw err;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkMobile);
    this.attachImagesToItems();
    // Wait a bit for the input to render
    this.$nextTick(() => {
      const inputEl = this.$refs.phoneInput?.$el?.querySelector('input');

      if (inputEl) {
        inputEl.addEventListener('paste', this.handlePaste);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
};
</script>


<style scoped lang="scss">
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);  /* Semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
@media (min-width: 769px) {
  .mobile-only {
    display: none;
  }
}
.img-tag {
  width: 100px;
  height: 100px;
}
.form-container {
  position: relative;
}
.hidden {
  display: none;
}

.page {
  height: 90vh;
  overflow-y: scroll !important;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
  justify-content: center;
}

.card {
  width: 200px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  transition: transform 0.2s;
  text-align: center;
}

.card:hover {
  transform: scale(1.05);
}

.card-img-top {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.card-body {
  padding: 1rem;
}

.card-text {
  margin: 0;
  font-weight: bold;
}

.button-container {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
}

#vgt-table td {
  text-align: center !important;
}

.accept-button,
.delete-button {
  border: none;
  padding: 8px 16px;
  margin: 5px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.accept-button {
  background-color: #28a745;
  color: white;
}

.delete-button {
  background-color: #dc3545;
  color: white;
}

.accept-button:hover,
.delete-button:hover {
  background-color: transparent;
  color: #333;
  outline: 1px solid #333;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-contentt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  width: 95%;
  max-width: 95%;
  max-height: 99vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-bodyy {
  flex: 1; /* Makes the body take up remaining space */
  overflow-y: auto; /* Enables vertical scrolling */
  padding: 1rem;
  width: 100%;
}
.modal-header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}
.cardi {
  position: relative;
  padding: 1rem;
  width: 100%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.9rem;
  background-color: var(--red-card);
  color: var(--text);
  cursor: pointer;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  transition: transform 0.3s ease;
}
.cbx {
  position: relative;
  width: 40px;
  height: 40px;
  border: 2px solid black;
  border-radius: 5px;
  vertical-align: middle;
  transition: background 0.1s ease;
  cursor: pointer;
  display: block;
}

.cbx:after {
  content: '';
  position: absolute;
  top: 8px;
  left: 14px;
  width: 10px;
  height: 17px;
  opacity: 0;
  transform: rotate(45deg) scale(0);
  border-right: 3px solid #fff;
  border-bottom: 3px solid #fff;
  transition: all 0.3s ease;
  transition-delay: 0.15s;
}

.lbl {
  margin-left: 5px;
  vertical-align: middle;
  cursor: pointer;
}

#cbx:checked ~ .cbx {
  border-color: transparent;
  background: #1d90dd;
  animation: jelly 0.6s ease;
}

#cbx:checked ~ .cbx:after {
  opacity: 1;
  transform: rotate(45deg) scale(1);
}

.cntr {
  position: relative;
}

@keyframes jelly {
  from {
    transform: scale(1, 1);
  }

  30% {
    transform: scale(1.25, 0.75);
  }

  40% {
    transform: scale(0.75, 1.25);
  }

  50% {
    transform: scale(1.15, 0.85);
  }

  65% {
    transform: scale(0.95, 1.05);
  }

  75% {
    transform: scale(1.05, 0.95);
  }

  to {
    transform: scale(1, 1);
  }
}

.hidden-xs-up {
  display: none!important;
}

.input {
  height: 20px;
  width: 150px;
  margin: 5px;
  border: none;
  padding: 1rem;
  border-radius: 2px;
  background: aliceblue;
  font-weight: 400;
  transition: 0.3s;
}

.input:focus {
  outline-color: #e8e8e8;
  background: #e8e8e8;
  box-shadow: inset 20px 20px 60px #c5c5c5,
  inset -20px -20px 60px #ffffff;
  transition: 0.3s;
}
.mob {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 767px){
  .cardi {
    display: flex;
    flex-direction: column;
    align-items: start;

  }
  .input {
    height: 20px;
    width: 100%;
    margin: 5px;
    border: none;
    padding: 1rem;
    border-radius: 2px;
    background: aliceblue;
    font-weight: 400;
    transition: 0.3s;
  }
  .mob {
    display: flex;
  }
  img {
    width: 100px;
    height: 100px;
  }

}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}

.card-1 {
  width: 90%;
  height: 100px;
  background: aliceblue;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  backdrop-filter: blur(10px);
  transition: 0.1s ease-in-out;
  margin: auto;
  margin-bottom: 10px;
}

.card-1:hover {
  cursor: pointer;
  transform: scale(1.05);
}

.img-c {
  width: 130px;
  height: 130px;
  margin-left: 10px;
  border-radius: 10px;
  background: linear-gradient(#d7cfcf, #9198e5);
}


.textBox {
  width: calc(100% - 90px);
  margin-left: 10px;
  color: white;

}

.textContent {
  color: black;
  margin-left: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.span {
  font-size: 10px;
}

.h1 {
  font-size: 16px;
  font-weight: bold;
}

.p {
  font-size: 12px;
  font-weight: lighter;
}

.header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}


.wrapper {
  width: 140px;
  height: 60px;
  margin: auto;
  position: relative;
  z-index: 1;
}

.circle {
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  background-color: black;
  left: 15%;
  transform-origin: 50%;
  animation: circle7124 .5s alternate infinite ease;
}

@keyframes circle7124 {
  0% {
    top: 60px;
    height: 5px;
    border-radius: 50px 50px 25px 25px;
    transform: scaleX(1.7);
  }

  40% {
    height: 20px;
    border-radius: 50%;
    transform: scaleX(1);
  }

  100% {
    top: 0%;
  }
}

.circle:nth-child(2) {
  left: 45%;
  animation-delay: .2s;
}

.circle:nth-child(3) {
  left: auto;
  right: 15%;
  animation-delay: .3s;
}

.shadow {
  width: 20px;
  height: 4px;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.9);
  position: absolute;
  top: 62px;
  transform-origin: 50%;
  z-index: -1;
  left: 15%;
  filter: blur(1px);
  animation: shadow046 .5s alternate infinite ease;
}

@keyframes shadow046 {
  0% {
    transform: scaleX(1.5);
  }

  40% {
    transform: scaleX(1);
    opacity: .7;
  }

  100% {
    transform: scaleX(.2);
    opacity: .4;
  }
}

.shadow:nth-child(4) {
  left: 45%;
  animation-delay: .2s
}

.shadow:nth-child(5) {
  left: auto;
  right: 15%;
  animation-delay: .3s;
}

.input {
  width: 100%;
  height: 44px;
  background-color: #05060f0a;
  border-radius: .5rem;
  padding: 0 1rem;
  margin: 10px;
  border: 2px solid transparent;
  font-size: 1rem;
  transition: border-color .3s cubic-bezier(.25,.01,.25,1) 0s, color .3s cubic-bezier(.25,.01,.25,1) 0s,background .2s cubic-bezier(.25,.01,.25,1) 0s;
}

.label {
  display: block;
  margin-bottom: .3rem;
  font-size: .9rem;
  font-weight: bold;
  color: #05060f99;
  transition: color .3s cubic-bezier(.25,.01,.25,1) 0s;
}

.input:hover, .input:focus, .input-group:hover .input {
  outline: none;
  border-color: #05060f;
}

.input-group:hover .label, .input:focus {
  color: #05060fc2;
}
</style>
